function loadPageContent(pageHandle) {
    // Define the URL of the page using the page handle
    const pageUrl = `/pages/${pageHandle}`;

    // Fetch page content
    fetch(pageUrl)
        .then(response => {
            if (response.ok) {
                return response.text(); // Get response as HTML text
            }
            throw new Error('Network response was not ok');
        })
        .then(html => {
            // Parse the HTML to extract only the content you need
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const pageContent = doc.querySelector('#MainContent'); // Adjust selector as needed

            // Find the target div and create a new wrapper div
            const targetDiv = document.querySelector('.size-chart-content div');
            const wrapperDiv = document.createElement('div');
            wrapperDiv.classList.add('custom-main-sizechart-content'); // Add the custom class
           $("div.size-chart-content").addClass('wrapper-size-guide');
          $("button.close-call").addClass('custom-close-icon');
            // Append the page content to the new wrapper div
            wrapperDiv.innerHTML = pageContent.innerHTML;

            // Insert the wrapper div into the target div
            targetDiv.innerHTML = ''; // Clear the existing content if any
            targetDiv.appendChild(wrapperDiv); // Append the wrapper div with the content
        })
        .catch(error => {
            console.error('Error loading page content:', error);
        });
}

// Call the function, passing the handle of the page you want to load
loadPageContent('size-guide');


function hasHorizontalScroll(element) {
  return $(element).get(0).scrollWidth > $(element).innerWidth();
}

// Example usage:


// $(".dsktop-mnu-jtpl").hover(function () {
//     $(this).toggleClass("active");
//  });

setTimeout(function(){

   $('#shopify-section-header').css('height','auto');

  $('#shopify-section-header').css('opacity','1')

},200)
$(document).ready(function() {
  $(".labdiamond-product").on("change", function () {
  var ringValue = $(this).val(); 
  $(".product-form form #labdiamond-product").val(ringValue);
});
    var location=window.location.href;
  console.log("location2",location);
  $(".dsktop-mnu-jtpl").last().click(function(event) {
    event.preventDefault(); // Prevents the default action of the click
    window.location.href = "https://cushlawhiting.com.au/pages/appointments"; // Redirect to the specified URL
    $(".mega-menu-page").hide(); // Hides the mega-menu
});
  $(".mobile-menu-jtpl").last().click(function(event) {
    event.preventDefault(); // Prevents the default action of the click
    window.location.href = "https://cushlawhiting.com.au/pages/appointments"; // Redirect to the specified URL
    $(".mega-menu-page").hide(); // Hides the mega-menu
});
    // Select the search button and the input field
    $(".header__search-icon").click(function(e) {
       $('.header__search-icon--closed').removeClass('show');

        $('.header__search-icon--open').addClass('show');  
    });
  
   
});

$(document).on("click",".dsktop-mnu-jtpl .mega-menu__title",function(event){
  event.preventDefault();

    $("sticky-header.header-wrapper").addClass("active");
});
 $(document).mouseup(function (e) {

     var popup = $(".header__search-bar.desktop");

     if (!$('.header__icons .header__search-icon').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {       

      popup.removeClass('active');

       $('.header__search-icon--closed').addClass('show');

        $('.header__search-icon--open').removeClass('show');       

     }

 });


$(document).on('click','.header__search-icon--open',function(){    

  $('.header__search-bar.desktop').removeClass('active');
  $('.header__search-icon--closed').addClass('show');
  $('.header__search-icon--open').removeClass('show');     


});
$(document).on('click', '#MainContent', function() {
 $('li.mega-menu.dsktop-mnu-jtpl').removeClass('active'); 
    $("sticky-header.header-wrapper").removeClass("active");
  })
  $(document).on('click', '.header__icon--cart', function() {
 $('li.mega-menu.dsktop-mnu-jtpl').removeClass('active'); 
     $("sticky-header.header-wrapper").removeClass("active");
  })
$(document).on('click','.header__search-icon--closed',function(){    
$('li.mega-menu.dsktop-mnu-jtpl').removeClass('active');
  $('.header__search-bar.desktop').addClass('active');
   setTimeout(function() {
        // Focus the input field once the search bar is revealed
        var inputField = $('.header__search-bar.desktop .header__search-bar--input');
        console.log(inputField.length);
        // Check if the input field exists and is visible
        if (inputField.length && inputField.is(':visible')) {
            inputField.focus();
        }
    }, 400);

});

// Mobile drawer state recovery.
// <details data-trigger-burger-open> toggles natively the moment it is parsed,
// but everything that actually shows the drawer arrives later from deferred
// scripts: HeaderDrawer's summary handler (global.js, on custom element upgrade)
// supplies "menu-opening", and sections-mega-menu.js supplies "mobile-menu-open"
// on DOMContentLoaded. Tapping MENU before both land natively opens the details
// with neither class, so details[open] styling hides MENU and BAG while no drawer
// renders behind it. Reconcile that desync back to a closed, usable state.
(function () {
  var details = document.querySelector("[data-trigger-burger-open]");
  if (!details) return;

  function reconcileDrawer() {
    if (!details.hasAttribute("open")) return;
    // Either class means a controller opened it deliberately: leave it alone.
    if (document.body.classList.contains("mobile-menu-open")) return;
    if (details.classList.contains("menu-opening")) return;
    details.removeAttribute("open");
  }

  reconcileDrawer();
  document.addEventListener("DOMContentLoaded", reconcileDrawer);
  window.addEventListener("load", reconcileDrawer);
})();

(function () {
  var desktopBp = 990;
  var scrollThreshold = 80;
  var scrollAtOpen = 0;
  var ticking = false;

  function isDesktop() {
    return window.innerWidth >= desktopBp;
  }

  // The slide/closing animation CSS is scoped to .mega-menu--full-height
  // (theme setting "mega_menu_full_height"). Without it the theme's instant
  // class toggle is the only close, so don't hold .active for the animation.
  function isFullHeight() {
    return !!document.querySelector(".header-wrapper.mega-menu--full-height");
  }

  function setMegaMenuHeaderOffset() {
    var section = document.getElementById("shopify-section-header");
    if (!section) return;
    // Always measure the header, never the panel. The closed panel is parked
    // above the viewport with a transform, so its own rect no longer reports
    // where it will open to; measuring it yielded 0 and made the panel a full
    // 100vh tall, overshooting the viewport bottom by the header's height.
    // The header's bottom edge is exactly the open panel's top in any case.
    var header = document.querySelector("sticky-header.header-wrapper") || document.querySelector(".header-wrapper") || section;
    var offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    // Compare against the element's own value rather than caching it: a section
    // re-render replaces the element and drops the inline style, and a cached
    // copy would then suppress the write forever, leaving the panel on the CSS
    // fallback and overshooting the viewport. Skipping identical writes still
    // keeps the panel height stable mid-animation.
    var next = offset + "px";
    if (section.style.getPropertyValue("--header-offset") === next) return;
    section.style.setProperty("--header-offset", next);
  }

  function closeDesktopMegaMenu() {
    if (!isDesktop()) return;
    var $open = $("li.mega-menu.dsktop-mnu-jtpl.active, li.mega-menu.dsktop-mnu-jtpl.open").not(".closing");
    if (!$open.length) return;
    var closeDuration = isFullHeight() ? 450 : 0;
    $open.addClass("closing");
    // Each close owns its own timer and only touches the items it captured:
    // concurrent closes must not cancel each other's cleanup.
    window.setTimeout(function () {
      // Only finish closing panels that are still closing: another item may have
      // been opened during the delay, which clears .closing on re-open.
      $open.filter(".closing").removeClass("active open closing");
      if (!$("li.mega-menu.dsktop-mnu-jtpl.active").length) {
        $("sticky-header.header-wrapper").removeClass("active");
      }
    }, closeDuration);
  }

  // Capture phase so this runs before the theme's own toggle on the button.
  document.addEventListener("click", function (e) {
    if (!isDesktop()) return;
    // Both branches below only matter for the animated (full-height) panels.
    if (!isFullHeight()) return;
    if (!e.target || !e.target.closest) return;
    var title = e.target.closest(".dsktop-mnu-jtpl .mega-menu__title");
    if (!title) return;
    var li = title.closest("li.mega-menu.dsktop-mnu-jtpl");
    if (!li) return;

    // Re-clicking the open menu closes it via the theme's instant class toggle,
    // which skips the closing animation the Escape/scroll paths use. Take over
    // so every close animates the same way.
    if (li.classList.contains("active") && !li.classList.contains("closing")) {
      e.preventDefault();
      e.stopPropagation();
      closeDesktopMegaMenu();
      return;
    }

    // Switching straight from one open menu to another: the outgoing panel is
    // removed instantly by the theme, so the incoming one has to appear
    // instantly too, or the header sits empty for the length of the slide.
    // Only a fresh open from a closed header gets the slide-down.
    var alreadyOpen = document.querySelector("li.mega-menu.dsktop-mnu-jtpl.active");
    if (!alreadyOpen || alreadyOpen === li) return;
    li.classList.add("mega-menu--no-anim");
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        li.classList.remove("mega-menu--no-anim");
      });
    });
  }, true);

  $(document).on("click", ".dsktop-mnu-jtpl .mega-menu__title", function () {
    if (!isDesktop()) return;
    $("li.mega-menu.dsktop-mnu-jtpl.closing").removeClass("closing");
    scrollAtOpen = window.scrollY || window.pageYOffset || 0;
    setMegaMenuHeaderOffset();
    window.requestAnimationFrame(setMegaMenuHeaderOffset);
  });

  $(document).on("keydown", function (e) {
    if (!isDesktop()) return;
    if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
      closeDesktopMegaMenu();
    }
  });

  $(window).on("scroll", function () {
    if (!isDesktop()) return;
    if (!$("li.mega-menu.dsktop-mnu-jtpl.active:not(.closing)").length) return;
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(y - scrollAtOpen) >= scrollThreshold) {
        closeDesktopMegaMenu();
      }
      ticking = false;
    });
  });

  setMegaMenuHeaderOffset();
  $(window).on("resize", setMegaMenuHeaderOffset);
})();

// custom.css drops the header's view-transition-name while a mega menu or
// search panel is open (so the panel's backdrop blur can see the page). That
// rule also holds at navigation start when a link inside the panel is clicked,
// so the header was snapshotted as part of the page and lifted away instead of
// staying put. pageswap fires before the outgoing snapshot: pin the name back
// inline (inline beats the :has() rule) so the header keeps its own group.
(function () {
  function header() {
    return document.getElementById("shopify-section-header");
  }
  window.addEventListener("pageswap", function () {
    var section = header();
    if (section) section.style.viewTransitionName = "site-header";
  });
  // Coming back via bfcache restores the DOM as it was left, inline pin
  // included, which would beat the :has() rule and kill the blur for good.
  window.addEventListener("pageshow", function (e) {
    var section = header();
    if (e.persisted && section) section.style.viewTransitionName = "";
  });
})();

// Desktop search dropdown: close on scroll, matching the mega menu panels.
(function () {
  var desktopBp = 990;
  var scrollThreshold = 80;
  var wheelThreshold = 40;
  var touchThreshold = 40;
  var scrollAtOpen = 0;
  var wheelDelta = 0;
  var touchStartY = null;
  var openedAt = 0;
  // Momentum from the flick that closed the panel (or the input's own focus
  // scroll) keeps firing scroll events for a moment after the panel opens.
  // Without this grace window those stale events close it again straight away,
  // which reads as "the button needs two clicks".
  var settleMs = 500;

  function isDesktop() {
    return window.innerWidth >= desktopBp;
  }

  function inGracePeriod() {
    if (Date.now() - openedAt >= settleMs) return false;
    // Re-baseline while settling so only movement after the panel is open counts.
    scrollAtOpen = scrollPos();
    wheelDelta = 0;
    return true;
  }

  function searchToggle() {
    return document.querySelector("[data-header-search-icon]");
  }

  function openSearchPanel() {
    return document.querySelector(".header__search-bar.desktop[data-search-bar].active");
  }

  function scrollPos() {
    // The panel can sit over a body-level scroller as well as the document one,
    // so read whichever actually moved rather than assuming window scrolling.
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  // The panel's open height is calc(100vh - --header-offset), so refresh the
  // offset from the live header before the curtain animates open.
  function setHeaderOffset() {
    var section = document.getElementById("shopify-section-header");
    if (!section) return;
    var header = document.querySelector("sticky-header.header-wrapper") || document.querySelector(".header-wrapper") || section;
    var next = Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + "px";
    if (section.style.getPropertyValue("--header-offset") === next) return;
    section.style.setProperty("--header-offset", next);
  }

  // top: 100% assumes the panel's offset parent ends exactly at the bottom of
  // the visible header. In the sticky state it doesn't — the header is taken
  // out of flow, its parent collapses, and the panel opens behind the header
  // with the search field hidden underneath it. Measure the real gap instead.
  function setPanelTop() {
    var section = document.getElementById("shopify-section-header");
    var panel = document.querySelector(".header__search-bar.desktop[data-search-bar]");
    if (!section || !panel) return;
    var header = document.querySelector("sticky-header.header-wrapper") || document.querySelector(".header-wrapper") || section;
    var parent = panel.offsetParent || section;
    var top = Math.round(header.getBoundingClientRect().bottom - parent.getBoundingClientRect().top);
    section.style.setProperty("--search-panel-top", Math.max(0, top) + "px");
  }

  function keepPanelPinned() {
    // The input is focused while the panel is still animating open, so the
    // browser scrolls it (and sometimes the page) to bring the field into view
    // — which is what buries the search field under the header. Undo both.
    var y = scrollPos();
    var restoreUntil = Date.now() + 250;
    function fix() {
      var panel = openSearchPanel();
      if (!panel) return;
      if (panel.scrollTop) panel.scrollTop = 0;
      if (Date.now() <= restoreUntil && Math.abs(scrollPos() - y) > 1) window.scrollTo(0, y);
    }
    fix();
    window.requestAnimationFrame(fix);
    window.setTimeout(fix, 100);
    window.setTimeout(fix, 500);
  }

  function syncToggleLabel() {
    // The SEARCH/CLOSE labels must always agree with the panel: a panel that is
    // closed while the header still reads CLOSE costs the shopper a wasted
    // click before search will reopen.
    var closedLabel = document.querySelector("[data-header-search-icon-closed]");
    var openLabel = document.querySelector("[data-header-search-icon-open]");
    var isOpen = !!openSearchPanel();
    if (closedLabel) closedLabel.classList.toggle("show", !isOpen);
    if (openLabel) openLabel.classList.toggle("show", isOpen);
  }

  function blurInsidePanel(panel) {
    // Hiding the panel does not blur what is inside it: the search field would
    // keep focus while invisible, so later keystrokes land in it and Enter
    // submits the form, navigating to /search out of nowhere.
    if (!panel) return;
    var el = document.activeElement;
    if (el && el.blur && panel.contains(el)) el.blur();
  }

  function closeSearchPanel() {
    var panel = openSearchPanel();
    if (!panel) return;
    // Hiding the panel does not blur what is inside it: the search field would
    // keep focus while invisible, so later keystrokes land in it and Enter
    // submits the form, navigating to /search out of nowhere.
    blurInsidePanel(panel);
    // Route the close through the toggle's own click handler so the search
    // script's internal open/closed flag stays in sync; stripping .active
    // directly would leave it thinking the panel is still open.
    var toggle = searchToggle();
    if (toggle) toggle.click();
    // Belt and braces: if that handler did not run (script not loaded yet, or
    // an error inside it), close by hand so the panel and the label can never
    // end up disagreeing.
    var stillOpen = openSearchPanel();
    if (stillOpen) stillOpen.classList.remove("active");
    syncToggleLabel();
  }

  // Predictive search results can make the open panel taller than the
  // screen, and then it scrolls (new-header-footer.css). A wheel or swipe
  // over it should scroll the results, not close the panel.
  function isScrollingPanel(e) {
    var panel = openSearchPanel();
    return !!(panel && e.target instanceof Node && panel.contains(e.target) && panel.scrollHeight > panel.clientHeight);
  }

  function maybeCloseOnScroll() {
    if (!isDesktop()) return;
    if (!openSearchPanel()) return;
    if (inGracePeriod()) return;
    if (Math.abs(scrollPos() - scrollAtOpen) < scrollThreshold) return;
    closeSearchPanel();
  }

  $(document).on("click", "[data-header-search-icon]", function () {
    scrollAtOpen = scrollPos();
    wheelDelta = 0;
    openedAt = Date.now();
    setHeaderOffset();
    setPanelTop();
    // This runs after the theme's own toggle handler, so the panel's state is
    // final here: if that click closed it, drop focus out of the hidden field.
    if (!openSearchPanel()) {
      blurInsidePanel(document.querySelector(".header__search-bar.desktop[data-search-bar]"));
      return;
    }
    keepPanelPinned();
  });

  // Every close path drops .active at once, but the curtain still takes 0.45s
  // to slide up. Hold a .closing class for that long so the blur gate in
  // custom.css (which needs .active or .closing) survives the animation, the
  // same way the mega menus keep .active through their own .closing state.
  // The 450ms matches the max-height transition in new-header-footer.css.
  (function () {
    var panel = document.querySelector(".header__search-bar.desktop[data-search-bar]");
    if (!panel) return;
    var timer = null;
    var wasActive = panel.classList.contains("active");
    new MutationObserver(function () {
      var isActive = panel.classList.contains("active");
      if (wasActive !== isActive) {
        window.clearTimeout(timer);
        panel.classList.toggle("closing", !isActive);
        if (!isActive) {
          timer = window.setTimeout(function () {
            panel.classList.remove("closing");
          }, 450);
        }
      }
      wasActive = isActive;
    }).observe(panel, { attributes: true, attributeFilter: ["class"] });
  })();

  $(window).on("resize", function () {
    setHeaderOffset();
    setPanelTop();
  });

  $(window).on("scroll", maybeCloseOnScroll);
  // Scroll alone is not enough: the open panel clips its own overflow, so a
  // wheel or touch gesture over it can be swallowed without the page moving.
  // Capture phase, so a handler that stops propagation cannot hide it.
  document.addEventListener("scroll", maybeCloseOnScroll, true);
  document.addEventListener(
    "wheel",
    function (e) {
      if (!isDesktop()) return;
      if (!openSearchPanel()) return;
      if (inGracePeriod()) return;
      if (isScrollingPanel(e)) return;
      wheelDelta += Math.abs(e.deltaY || 0);
      if (wheelDelta >= wheelThreshold) closeSearchPanel();
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    "touchstart",
    function (e) {
      touchStartY = e.touches && e.touches[0] ? e.touches[0].clientY : null;
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    "touchmove",
    function (e) {
      if (!isDesktop()) return;
      if (!openSearchPanel()) return;
      if (inGracePeriod()) return;
      if (isScrollingPanel(e)) return;
      // Same distance threshold as the wheel path: a touch-drag to place the
      // caret or select text in the search field must not close the panel.
      if (touchStartY === null || !e.touches || !e.touches[0]) return;
      if (Math.abs(e.touches[0].clientY - touchStartY) < touchThreshold) return;
      closeSearchPanel();
    },
    { capture: true, passive: true }
  );
})();

(function () {
  function getMobileSearchQuery(form) {
    var input = form.querySelector('[name="q"]');
    return input ? String(input.value || "").trim() : "";
  }

  // Mobile mega-menu search: only navigate on explicit submit with a query
  $(document).on("submit", "form[data-mobile-mega-search]", function (e) {
    if (!getMobileSearchQuery(this)) {
      e.preventDefault();
    }
  });

  $(document).on("click", "[data-mobile-search-submit]", function (e) {
    e.preventDefault();
    var form = this.closest("form[data-mobile-mega-search]");
    if (!form) return;
    if (!getMobileSearchQuery(form)) return;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
})();

(function () {
  // The BUCKS app embed injects its currency box into the header icons; the
  // design wants it in the footer. Move it once it appears and again if the
  // app or a section re-render puts it back in the header.
  function moveBucksToFooter() {
    var slot = document.getElementById("footer-bucks-currency");
    if (!slot) return;
    var boxes = document.querySelectorAll(".buckscc-currency-box");
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (slot.contains(box)) continue;
      // A re-inject after the first move must not stack a second widget in
      // the footer. Keep the newest node: it is the one the app just built and
      // still holds a reference to, so its later updates land on screen.
      var stale = slot.querySelector(".buckscc-currency-box");
      if (stale) stale.remove();
      slot.appendChild(box);
    }
  }

  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    moveBucksToFooter();
    if (document.querySelector("#footer-bucks-currency .buckscc-currency-box") || tries > 40) {
      window.clearInterval(poll);
    }
  }, 500);

  var headerEl = document.getElementById("shopify-section-header");
  if (headerEl) {
    new MutationObserver(moveBucksToFooter).observe(headerEl, { childList: true, subtree: true });
  }
})();

// $(".dsktop-mnu-jtpl").hover(function () {

//   $('sticky-header.header-wrapper').toggleClass('active');

// });


$(document).on( 'scroll', function(){

 var scroll =  $(window).scrollTop();
  if($(window).width() < 989 && scroll > 1){
        var mainWindowHgt = $(window).height();
  
    $(".sw-right-side-mnu-jtpl").addClass("open-sticky-header-jtpl");
    $('header .header__inline-menu').css("height", mainWindowHgt+2);
  }else{
     $(".sw-right-side-mnu-jtpl").removeClass("open-sticky-header-jtpl");
  }

});
  $(window).resize(function(){
if($('body').hasClass('template--collection')== true){
    if (hasHorizontalScroll(".metafields")) {
  $(".metafields").addClass("scroll-bar-start")
      $(".cstm-jtpl-disclosurePop").addClass("scroll-bar-start-main")
      $("#main-collection-filters").addClass("scroll-bar-start-wrap")
      
} else {
 $(".metafields").removeClass("scroll-bar-start")
 $(".cstm-jtpl-disclosurePop").removeClass("scroll-bar-start-main")
  $("#main-collection-filters").removeClass("scroll-bar-start-wrap")
}
}
    var w = $(window).width();

    w = parseInt(w);

    console.log(w)

     if(w > 989 ){
    $(".hide-from-dsktop").parent(".shopify-section").hide();
       $(".hide-from-mobile").parent(".shopify-section").show();
 $('header .header__inline-menu').css("height", "fit-content");
       // $('.product').addClass('desktop-product-grid');
       
  }
  if($(window).width() < 989){
      var mainWindowHgt = $(window).height();
  $('header .header__inline-menu').css("height", mainWindowHgt);
    $(".hide-from-mobile").parent(".shopify-section").hide();
    $(".hide-from-dsktop").parent(".shopify-section").show();
     // $('.product').removeClass('desktop-product-grid');
  }
      if($(window).width() > 749){
  $(".fw-slider-slide__media").removeClass("with-mobile-image")
}else{
    $(".fw-slider-slide__media").addClass("with-mobile-image")
}
});


// document.addEventListener('flickity:scroll', function() {
//   window.preventDefault();
// });

//    var scrollHandle = setInterval(flicktyLoadInit, 100);
// function flicktyLoadInit(){
//   if($("multicolumn-slider-component").find(".flickity-slider").length > 0){
   
//     clearInterval(scrollHandle);
//   }
// }
 function formatPrice(value) {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: value % 1 === 0 ? 0 : 2, // No decimals for whole numbers
      maximumFractionDigits: 2, // Up to 2 decimals for non-whole numbers
    }).format(value);
  }

$(document).ready(function(){

      if ($(window).width() <= 768) {  // You can adjust the max-width as per your mobile breakpoint
    // Select the card-wrapper__inner--mobile element
    var mobileCard = $('.card-wrapper__inner--mobile .card .card__inner .media .flickity-viewport .flickity-slider a');
       if (mobileCard.hasClass("is-selected")) {
    // If it's selected, remove the 'hide-image' class and add the 'show-image' class
    mobileCard.find("img").removeClass("hide-image");
    mobileCard.find("img").addClass("show-image");
  }
       else {
    // If it's not selected, add the 'hide-image' class and remove the 'show-image' class
    mobileCard.find("img").addClass("hide-image");
    mobileCard.find("img").removeClass("show-image");
  }
    
    }
   $('.btn-close-jtpl').click(function(){
     // alert("hai")
    //Some code
    window.closeEgCartDrawer();
});
  /****************Bundle product from metafields********************************/
 if($(".bundles_metafield").length > 0){
$("body").on("change",".bundles_metafield",function(e){
  e.preventDefault();
  var $this = $(this);
var bundle_price= 0;
  var bundle_html = '';
  $(".bundles_metafield").each(function(index){
    var $this2 = $(this);
     if($(this).hasClass("bundle-1") == true){
       console.log("bundle==> true");
      var bundle_1 = $(".bundles_metafield.bundle-1").val();
          $(".bundle_items-jtpl .bundle_variant-jtpl").val(bundle_1); 
       if($("body").hasClass("personalization-rec") || $("body").hasClass("personalization")){
          $(".personalization-submit").find("input[name='items[1][id]']").val(bundle_1);
       }
    }else{
       console.log("bundle==> false");
      var bundle_1 = $(".bundles_metafield.bundle-1").val();
      var bundle_2 = $(".bundles_metafield.bundle-2").val();
     //  console.log("bundle=="+bundle_1+"==="+bundle_2);
       if(bundle_1 != '0'){
         bundle_html +=`<input type="hidden" name="items[0][quantity]" value="1">
                        <input type="hidden" name="items[0][id]" class="bundle_variant1-jtpl" value="`+bundle_1+`">`;
                      
       }
       if(bundle_2 != '0'){
         bundle_html +=`<input type="hidden" name="items[1][quantity]" value="1">
                        <input type="hidden" name="items[1][id]" class="bundle_variant2-jtpl" value="`+bundle_2+`">`;
       }
       $(".bundle_forms-jtpl").html('');
       $(".bundle_forms-jtpl").html(bundle_html);
       
       $(".bundle_items-jtpl-2 .bundle_variant1-jtpl").val(bundle_1); 
       $(".bundle_items-jtpl-2 .bundle_variant2-jtpl").val(bundle_2); 
    }
    var price = $(this).find("option:selected").attr("data-price");
    //console.log(price);
    if (price > 0  || !isNaN(price)) {
      bundle_price = parseFloat(price) + parseFloat(bundle_price);
    }
  
  });
 
      var defaultPrice = $(".bundles_metafield option[data-default='true']").attr("data-price");
   
     var price_main = parseFloat(bundle_price) + parseFloat(defaultPrice);
     price_main = price_main / 100;
      price_main = formatPrice(price_main); // Format price
       $(".product__info-wrapper .price-item.price-item--regular").text(price_main+" AUD")
    
    
  
});
  
}
 /****************Bundle product from metafields********************************/
  //     if($('.HomePage_banner-one').hasClass('fw-slider')){

  //   $('#shopify-section-header').addClass('main_banner')

  // }
  if($('body').hasClass('template--collection')== true){
    if (hasHorizontalScroll(".metafields")) {
  $(".metafields").addClass("scroll-bar-start")
      $(".cstm-jtpl-disclosurePop").addClass("scroll-bar-start-main")
      $("#main-collection-filters").addClass("scroll-bar-start-wrap")
      
} else {
 $(".metafields").removeClass("scroll-bar-start")
 $(".cstm-jtpl-disclosurePop").removeClass("scroll-bar-start-main")
  $("#main-collection-filters").removeClass("scroll-bar-start-wrap")
}
  }
   $(".collection-faq-jtpl").parent(".spaced-section.text-layout").hide();
 //    if($(window).width() < 989 ){
 //      // $('div.product').removeClass('desktop-product-grid');
 //        var mainWindowHgt = $(window).height();
 //  $('header .header__inline-menu').css("height", mainWindowHgt);
 // }


 function handleResize() {
   
        if ($(window).width() < 989) {
            $('.mega-menu___links-wrapper---jtpl').hide();
            // Keep mixed-page second-layer lists open (no accordion)
            $('.mega-menu-page__link-item--inner-list').hide();
            $('.mobile-menu-jtpl .mobile-second-layer__body .mega-menu-page__link-item--inner-list').show();
            $('.mobile-menu-jtpl .mobile-second-layer__body .mega-menu___links-wrapper---jtpl').show();
            
            // Remove any existing click event handlers to avoid multiple bindings
            $('.mega-menu-page__link-item--subtitle').off('click');
            $('.mega-menu-page__link-item--subtitle').not('.mega-menu-page__featured-heading, .mega-menu-page__category-heading').on('click', function() {
                $(this).next('ul.mega-menu-page__link-item--inner-list').toggle();
                $(this).next('.mega-menu___links-wrapper---jtpl').toggle();
                $(this).toggleClass("active-open-jtpl");
            });
            $('div.product').removeClass('desktop-product-grid');
            var mainWindowHgt = $(window).height();
            $('header .header__inline-menu').css("height", mainWindowHgt);
        } else {
            $('.mega-menu-page__link-item--inner-list').show();
            $('.mega-menu___links-wrapper---jtpl').show();
        }
    }

    // Call the function on page load
    handleResize();

    // Bind the function to the window resize event
    $(window).resize(handleResize);

  
  if($(window).width() > 749){
  $(".fw-slider-slide__media").removeClass("with-mobile-image")
}else{
    $(".fw-slider-slide__media").addClass("with-mobile-image")
}
     $(document).on('click','.close-jtpl-crr',function(){
      $(this).parents('.menu-drawer-container').removeAttr("open");
      $('header').removeClass('mobile-menu-open');
      $('body').removeClass('mobile-menu-open');
    $('nav').removeClass('opned-jtpl open-currency-jtpl');
     $(".back-crr-btn-jtpl").remove();
  }); 
     $(document).on('click','.mobile-facets__label',function(){
       setTimeout(function(){
         var filter_val_count =  $(".mobile-facets__count_custm").html();
       filter_val_count = $.trim(filter_val_count);
       var filter_value = filter_val_count.replace(')','');
       var filter_value = filter_value.replace('(','');
     $(".mobile-facets__count").html("Show "+filter_value+" result(s)")
       
       },1500);
      
  });
  

  const myTimeLoad = setTimeout(optionLoad, 1500);

  function optionLoad(){
    
  var Add_to_cart_text_load = $('.product-form__buttons .product-form__btn').html();

        if($.trim(Add_to_cart_text_load )== "Sold Out"){
          $('.product-form__buttons .product-form__btn').addClass('out-of-stock-jtpl');
        }
        else {
           $('.product-form__buttons .product-form__btn').removeClass('out-of-stock-jtpl');
        }
  }


  

  $(document).on('change','.select__select',function(){
    
    const myTimeout = setTimeout(myGreeting, 1000);
    function myGreeting() {
      var Add_to_cart_text = $('.product-form__buttons .product-form__btn').text();

      if(Add_to_cart_text == 'Sold out'){
        $('.product-form__buttons .product-form__btn').addClass('out-of-stock-jtpl');
      }
      else{
         $('.product-form__buttons .product-form__btn').removeClass('out-of-stock-jtpl');
      }
        
    }

  })




  
  $(document).on('click','.mobile-facets__open',function(event){
    event.preventDefault();
    // e.stopPropagation();
    $('.cstm-jtpl-disclosurePop').attr('open','');
    // $('.sw-right-side-mnu-jtpl').addClass('hidden');
    $('.cstm-jtpl-mobile-facts').attr('open','')
       // $('.cstm-jqu-jtpl').addClass('hidden');
  })

  $(document).on('click','.mobile-facets__close',function(event){
    event.preventDefault();
    // e.stopPropagation();
       // $('.cstm-jtpl-disclosurePop').removeAttr('open','');
  
   //     setTimeout(function() {
   //      $('.sw-right-side-mnu-jtpl').removeClass('hidden');
   //       $('.cstm-jqu-jtpl').removeClass('hidden');
   // }, 500);
    // $('.cstm-jtpl-mobile-facts').removeAttr('open','')
  });
  $(document).on('click','.apply-cstm-jtpl',function(event){
  $('.sw-right-side-mnu-jtpl').removeClass('hidden');
     });
 $(document).on('click','[filter-variable-pass]',function(e){    
      var filterDataValue = $(this).children('input').val();
      const queryString = window.location.search;
     const urlParams = new URLSearchParams(queryString);
    const product = urlParams.get('sort_by');
   var filterDataURL = window.history.replaceState(null, null, "?filter.v.price.gte=&filter.v.price.lte=&sort_by="+filterDataValue);
    var pageURL = $(location).attr("href");
    $.ajax({
      url: pageURL,
      type: 'GET',
      dataType: 'HTML',
      success: function(filter_data){        
        setTimeout(function(){              
        var filterHeading = $(filter_data).find('#main-collection-filters').html();
        $('#main-collection-filters').html(filterHeading);

        var filterContent = $(filter_data).find('#CollectionProductGrid').html();
        $('#CollectionProductGrid').html(filterContent)
          $("body").removeClass("overflow-hidden-mobile");
          $('.sw-right-side-mnu-jtpl').removeClass('hidden');

          $(".sortByMobileOptions-jtpl .radio-label").find("input[value='"+filterDataValue+"']").parents(".radio-label").addClass("active_sortby_jtpl");
           $("body").removeClass("overflow-cstm-filter");
        },100)
      },
      error: function(){
        console.log("fail")
      }
    })
    $(this).addClass('active');
  })



  

     if($(window).width() > 989){
   $(".hide-from-dsktop").parent(".shopify-section").hide();
       $(".hide-from-mobile").parent(".shopify-section").show();
       
  }
  if($(window).width() < 989){
    $(".hide-from-mobile").parent(".shopify-section").hide();
    $(".hide-from-dsktop").parent(".shopify-section").show();
  }



  /******close sub navigation*****/



      $(document).on('click', '.mega-menu-page__link-item--children', function(e){
    // e.preventDefault();
   $(this).parents('.mega-menu-page__link-item').addClass('opned-jtpl-child');
  $(this).parents('.cstm-jqu-jtpl').addClass('nav-child-opened')
        
        
  });
        $(document).on('click', '.cstm-open-class-jtpl', function(e){
    // e.preventDefault();
   
  // $(this).parents('.cstm-jqu-jtpl').addClass('nav-child-opened')  
  });

 
  //  $(document).on('click', '.close-jtpl-crr', function(e){
  //   // e.preventDefault();
  //  $('body').find('nav').removeClass('cstm-contnt-open-jtpl');
  // // $(this).parents('.cstm-jqu-jtpl').addClass('nav-child-opened')  
  // });
  

   $(document).on('click','.currncy-opn-add-jtpl',function(e){
     // New mobile footer currency uses the native selectFx dropdown instead of the full panel.
     if ($(this).closest('.mobile-nav-currency').length || $(this).hasClass('mobile-nav-currency')) {
       return;
     }
     $("nav").find(".cs-placeholder").html("Currency");
    $(this).parents('.cstm-jqu-jtpl').toggleClass('opned-jtpl open-currency-jtpl');
     // $('.cs-placeholder').trigger("click");
      $(".open-currency-jtpl").scrollTop(0);
     
      setTimeout(function(){ 
        var cstm_back = "back-crr-btn-jtpl";
        $(".cs-placeholder").append("<span class="+ cstm_back +">Back</span>");
      } ,100);  
  });  

         $(document).on('click','.back-crr-btn-jtpl',function(e){
            e.stopPropagation();
         $('nav').removeClass('opned-jtpl open-currency-jtpl');
          $(this).remove();      
  });

       $(document).on('click','[data-option]',function(e){
         e.stopPropagation();
         if ($(this).closest('.mobile-nav-currency').length) {
           return;
         }
    $('nav').removeClass('opned-jtpl open-currency-jtpl');
        $("nav").find(".cs-placeholder").prepend("Currency / "); 
     $(".back-crr-btn-jtpl").remove();
  });

  
  $(document).on('click','.mobile-menu-jtpl',function(e){
    // e.preventDefault();
   
    $(this).parents('.cstm-jqu-jtpl').addClass('opned-jtpl')
    // $('.cstm-jqu-jtpl').addClass('opned-jtpl');
  });



               

  
   $('body').on('click', '[data-menu-dropdown-child]', function(e){
       // e.preventDefault();
      var $this = $(this);
     // $(".mega-menu-page__link-item--children").removeClass("active");
     // $(this).parents(".mega-menu-page__link-item--children").addClass("active");
  
   });
  
   $('body').on('click', '[data-mobile-menu-back-child]', function(e){
     // e.preventDefault();
      e.stopPropagation();
      var $this = $(this);
      $(this).parents(".mega-menu-page__link-item--children").addClass("closing");
      // $(".mega-menu-page__link-item--children").removeClass("active");
      $this.parents(".mega-menu-page__link-item--children").removeClass("closing");
   // $this.parentsUntil(".mega-menu-page__link-item.opned-jtpl-child").removeClass('opned-jtpl-child');
     $("body").find('.mega-menu-page__link-item').removeClass('opned-jtpl-child');
     $("body").find('.cstm-jqu-jtpl').removeClass('nav-child-opened');

     
       // $(".mega-menu-page__link-item.opned-jtpl-child").each(function(){
       //   console.log($(this).hasClass("opned-jtpl-child"));
       //   $(this).removeClass("opned-jtpl-child");
       // });
   });

   $("body").on("click", ".mega-menu.dsktop-mnu-jtpl", function() {
        $(this).find(".mega-menu-page__link-title-link-list-wrapper").each(function() {
        $(this).find("ul.mega-menu-page__link-item--inner-list").attr("data-menu-sub-active","true");
        });

});
   $('body').on('click', '[data-menu-dropdown-mixed]', function(e){
       // e.preventDefault();
      var $this = $(this);
      $('body').find('nav').addClass('cstm-contnt-open-jtpl');
      $(".mega-menu-page__link-item--mixed-jtpl").removeClass("active");
     $(this).parents(".mega-menu-page__link-item--mixed-jtpl").find(".mega-menu-page__link-item--inner-list").attr("data-menu-sub-active",true);
     $(this).parents(".mega-menu-page__link-item--mixed-jtpl").find(".mega-menu-page__children").attr("data-menu-mobile-sub-active",true);
      $(this).parents(".mega-menu-page__link-item--mixed-jtpl").addClass("active");
   });
   $('body').on('click', '[data-mobile-menu-back-mixed]', function(e){
        // $('nav.cstm-jqu-jtpl.header__inline-menu').removeClass('cstm-contnt-open-jtpl');
      $(this).parents("nav.cstm-jqu-jtpl.header__inline-menu").removeClass('cstm-contnt-open-jtpl');
     // e.preventDefault();
      var $this = $(this);
      $(this).parents(".mega-menu-page__link-item--mixed-jtpl").addClass("closing");
     $(".mega-menu-page__link-item--mixed-jtpl").removeClass("active");
       $this.parents(".mega-menu-page__link-item--mixed-jtpl").removeClass("closing");
     $(".mega-menu-page__link-item--mixed-jtpl").find(".mega-menu-page__link-item--inner-list").attr("data-menu-sub-active",true);
     $(".mega-menu-page__link-item--mixed-jtpl").find(".mega-menu-page__children").attr("data-menu-mobile-sub-active",true);
    
     // $("body").find('.mega-menu-page__link-item').removeClass('opned-jtpl-child');
 
   });
  });

     
$(document).ready(function() {


  var klaviyo_test = setInterval(klaviyoTextUpdate,1000);
  
  function klaviyoTextUpdate(){
//   alert($("#email_01J9X1FM5Z57J3HQNQC6J7BKMM").length);
  if($(".klaviyo-form-UcXjfV  input").length > 0 ){
   console.log("Hello--here");
   if($("span.email-label").length < 1 ){
  $(".klaviyo-form-UcXjfV input:first").after("<span class='email-label'>Email Address</span>");
     }
    clearInterval(klaviyo_test);
  }
    $('.klaviyo-form-UcXjfV input').click(function(){
    $('.klaviyo-form-UcXjfV.klaviyo-form.form-version-cid-1 button').addClass("sign-up-button");
});
    var $input = $('.klaviyo-form-UcXjfV input');
    var $button = $('.klaviyo-form-UcXjfV.klaviyo-form.form-version-cid-1 button');
    var $input_val = $('.klaviyo-form-UcXjfV input').val();
    
    $input.keyup(function () {
        $button.addClass('sign-up-button');
    });

    $input.on('blur', function () {
        //$button.removeClass('sign-up-button');
        var $input_val = $('.klaviyo-form-UcXjfV input').val();
  if($input_val == ''){
       $button.removeClass('sign-up-button');
  }
    });
    
  }




  
  // $(".sortByMobileOptions-jtpl").find("div.radio-label")[0].addClass("active_sortby_jtpl");
    $(".sortByMobileOptions-jtpl div.radio-label:nth-child(1)").addClass('active_sortby_jtpl');
  	// Reference the tab links.
	const tabLinks = $('#tab-links li a');
	
	// Handle link clicks.
	tabLinks.click(function(event) {
		var $this = $(this);
		
		// Prevent default click behaviour.
		event.preventDefault();
		
		// Remove the active class from the active link and section.
		$('#tab-links a.active, section.active').removeClass('active');
		
		// Add the active class to the current link and corresponding section.
		$this.addClass('active');
		$($this.attr('href')).addClass('active');
	});






  
  
  $('.product__thumbnails-item').each(function () {
   var get_img_height =  $(this).find('img'); 
   if ($(this).find('img').length == 0) {
      $(this).addClass('not-active');
    }else{

$(this).removeClass('not-active');
   }
});
 if(window.location.href.indexOf("products") > -1) {
var myReviewInterval = setInterval(reviewsInterval ,3000);
function reviewsInterval() {
  
if($('.product__info-wrapper .stamped-badge').length > 0){

var reviews_count = parseInt($('.product__info-wrapper .stamped-badge-caption').attr('data-reviews'));
if(reviews_count == 0 ){
$('.product__info-wrapper .stamped-badge-caption').append('<span class="no-reviews-text">Write a review</span>');
}
  clearInterval(myReviewInterval);

}

}
}



  
$('#ProductPopup-enquire, #ModalClose-enquire').click(function() {
		$(this).toggleClass('active');

	 $(".product-popup-modal").toggleClass('form-product-popup-modal');
	});
  
  $("#PopupModal-enquire").click(function(e){     
	 var container = $(".product-popup-modal__content");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
         e.preventDefault();
         $("#ModalClose-enquire").trigger('click');
         return false;
    }
	});


/**** newsletter popup start ****/
  
    function setCookie(cname, cvalue, exdays) { // Set Cookies function
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function removePopup(){
         $(".newsletter-popup.newsletter.center").css("display", "none");
          $("body").removeClass("custom-newsletter-popup");
          $("html").css("overflow-x", "none");
          setCookie("popup_close", "email_popup_close", 30); // Set Cookies function invoke
    };
  
    function newsletter_popup() {
      $(".newsletter-popup.newsletter.center").css("display", "block");
      $("body").addClass("custom-newsletter-popup");
      $("html").css("overflow-x", "hidden");
      
      $(document).on("click", ".newsletter-popup__close", function () {  // click function newsletter-popup-close
       removePopup();
      });
      $('.newsletter-popup.newsletter.center form').submit(function () {
          console.log('form submited set cookies');
            setTimeout(removePopup(), 2000);
      });
    }

      function getCookie(cname) {           // Get Cookies function
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  var popup_lenght = $(".newsletter-popup.newsletter").length;
  if(popup_lenght == '1'){
    if (getCookie("popup_close") === "email_popup_close") {     // Get Cookies function Invoke
      $(".newsletter-popup.newsletter").css("display", "none");
      $("body").removeClass("custom-newsletter-popup");
      $("html").css("overflow-x", "none");
    } else {
        if(window.location.href === "https://cushlawhiting.com.au/challenge#contact_form"){
          removePopup();
        }
        setTimeout(newsletter_popup, 3000);   // SetTimeout Invoke
    }
    }
$('.text-layout__accordion--body').removeClass('expanded');
$('.text-layout__accordion--body').css('height',"0");
$("input.text-layout__accordion--checkbox").removeAttr("checked");
/**** newsletter popup end ****/


  
});






var countriesVal={countries:[{country:"Afghanistan",states:["Badakhshan","Badghis","Baghlan","Balkh","Bamian","Daykondi","Farah","Faryab","Ghazni","Ghowr","Helmand","Herat","Jowzjan","Kabul","Kandahar","Kapisa","Khost","Konar","Kondoz","Laghman","Lowgar","Nangarhar","Nimruz","Nurestan","Oruzgan","Paktia","Paktika","Panjshir","Parvan","Samangan","Sar-e Pol","Takhar","Vardak","Zabol"]},{country:"Albania",states:["Berat","Dibres","Durres","Elbasan","Fier","Gjirokastre","Korce","Kukes","Lezhe","Shkoder","Tirane","Vlore"]},{country:"Algeria",states:["Adrar","Ain Defla","Ain Temouchent","Alger","Annaba","Batna","Bechar","Bejaia","Biskra","Blida","Bordj Bou Arreridj","Bouira","Boumerdes","Chlef","Constantine","Djelfa","El Bayadh","El Oued","El Tarf","Ghardaia","Guelma","Illizi","Jijel","Khenchela","Laghouat","Muaskar","Medea","Mila","Mostaganem","M'Sila","Naama","Oran","Ouargla","Oum el Bouaghi","Relizane","Saida","Setif","Sidi Bel Abbes","Skikda","Souk Ahras","Tamanghasset","Tebessa","Tiaret","Tindouf","Tipaza","Tissemsilt","Tizi Ouzou","Tlemcen"]},{country:"Andorra",states:["Andorra la Vella","Canillo","Encamp","Escaldes-Engordany","La Massana","Ordino","Sant Julia de Loria"]},{country:"Angola",states:["Bengo","Benguela","Bie","Cabinda","Cuando Cubango","Cuanza Norte","Cuanza Sul","Cunene","Huambo","Huila","Luanda","Lunda Norte","Lunda Sul","Malanje","Moxico","Namibe","Uige","Zaire"]},{country:"Antarctica",states:[]},{country:"Antigua and Barbuda",states:["Barbuda","Redonda","Saint George","Saint John","Saint Mary","Saint Paul","Saint Peter","Saint Philip"]},{country:"Argentina",states:["Buenos Aires","Buenos Aires Capital","Catamarca","Chaco","Chubut","Cordoba","Corrientes","Entre Rios","Formosa","Jujuy","La Pampa","La Rioja","Mendoza","Misiones","Neuquen","Rio Negro","Salta","San Juan","San Luis","Santa Cruz","Santa Fe","Santiago del Estero","Tierra del Fuego","Tucuman"]},{country:"Armenia",states:["Aragatsotn","Ararat","Armavir","Geghark'unik'","Kotayk'","Lorri","Shirak","Syunik'","Tavush","Vayots' Dzor","Yerevan"]},{country:"Australia",states:["Victoria","New South Wales","Western Australia","South Australia","Australian Capital Territory","Queensland","Tasmania","Northern Territory"]},{country:"Austria",states:["Burgenland","Kaernten","Niederoesterreich","Oberoesterreich","Salzburg","Steiermark","Tirol","Vorarlberg","Wien"]},{country:"Azerbaijan",states:["Abseron Rayonu","Agcabadi Rayonu","Agdam Rayonu","Agdas Rayonu","Agstafa Rayonu","Agsu Rayonu","Astara Rayonu","Balakan Rayonu","Barda Rayonu","Beylaqan Rayonu","Bilasuvar Rayonu","Cabrayil Rayonu","Calilabad Rayonu","Daskasan Rayonu","Davaci Rayonu","Fuzuli Rayonu","Gadabay Rayonu","Goranboy Rayonu","Goycay Rayonu","Haciqabul Rayonu","Imisli Rayonu","Ismayilli Rayonu","Kalbacar Rayonu","Kurdamir Rayonu","Lacin Rayonu","Lankaran Rayonu","Lerik Rayonu","Masalli Rayonu","Neftcala Rayonu","Oguz Rayonu","Qabala Rayonu","Qax Rayonu","Qazax Rayonu","Qobustan Rayonu","Quba Rayonu","Qubadli Rayonu","Qusar Rayonu","Saatli Rayonu","Sabirabad Rayonu","Saki Rayonu","Salyan Rayonu","Samaxi Rayonu","Samkir Rayonu","Samux Rayonu","Siyazan Rayonu","Susa Rayonu","Tartar Rayonu","Tovuz Rayonu","Ucar Rayonu","Xacmaz Rayonu","Xanlar Rayonu","Xizi Rayonu","Xocali Rayonu","Xocavand Rayonu","Yardimli Rayonu","Yevlax Rayonu","Zangilan Rayonu","Zaqatala Rayonu","Zardab Rayonu","Ali Bayramli Sahari","Baki Sahari","Ganca Sahari","Lankaran Sahari","Mingacevir Sahari","Naftalan Sahari","Saki Sahari","Sumqayit Sahari","Susa Sahari","Xankandi Sahari","Yevlax Sahari","Naxcivan Muxtar"]},{country:"Bahamas",states:["Acklins and Crooked Islands","Bimini","Cat Island","Exuma","Freeport","Fresh Creek","Governor's Harbour","Green Turtle Cay","Harbour Island","High Rock","Inagua","Kemps Bay","Long Island","Marsh Harbour","Mayaguana","New Providence","Nichollstown and Berry Islands","Ragged Island","Rock Sound","Sandy Point","San Salvador and Rum Cay"]},{country:"Bahrain",states:["Al Hadd","Al Manamah","Al Mintaqah al Gharbiyah","Al Mintaqah al Wusta","Al Mintaqah ash Shamaliyah","Al Muharraq","Ar Rifa' wa al Mintaqah al Janubiyah","Jidd Hafs","Madinat Hamad","Madinat 'Isa","Juzur Hawar","Sitrah"]},{country:"Bangladesh",states:["Barisal","Chittagong","Dhaka","Khulna","Rajshahi","Sylhet"]},{country:"Barbados",states:["Christ Church","Saint Andrew","Saint George","Saint James","Saint John","Saint Joseph","Saint Lucy","Saint Michael","Saint Peter","Saint Philip","Saint Thomas"]},{country:"Belarus",states:["Brest","Homyel","Horad Minsk","Hrodna","Mahilyow","Minsk","Vitsyebsk"]},{country:"Belgium",states:["Antwerpen","Brabant Wallon","Brussels","Flanders","Hainaut","Liege","Limburg","Luxembourg","Namur","Oost-Vlaanderen","Vlaams-Brabant","Wallonia","West-Vlaanderen"]},{country:"Belize",states:["Belize","Cayo","Corozal","Orange Walk","Stann Creek","Toledo"]},{country:"Benin",states:["Alibori","Atakora","Atlantique","Borgou","Collines","Donga","Kouffo","Littoral","Mono","Oueme","Plateau","Zou"]},{country:"Bermuda",states:["Devonshire","Hamilton","Hamilton","Paget","Pembroke","Saint George","Saint George's","Sandys","Smith's","Southampton","Warwick"]},{country:"Bhutan",states:["Bumthang","Chukha","Dagana","Gasa","Haa","Lhuntse","Mongar","Paro","Pemagatshel","Punakha","Samdrup Jongkhar","Samtse","Sarpang","Thimphu","Trashigang","Trashiyangste","Trongsa","Tsirang","Wangdue Phodrang","Zhemgang"]},{country:"Bolivia",states:["Chuquisaca","Cochabamba","Beni","La Paz","Oruro","Pando","Potosi","Santa Cruz","Tarija"]},{country:"Bosnia and Herzegovina",states:["Una-Sana [Federation]","Posavina [Federation]","Tuzla [Federation]","Zenica-Doboj [Federation]","Bosnian Podrinje [Federation]","Central Bosnia [Federation]","Herzegovina-Neretva [Federation]","West Herzegovina [Federation]","Sarajevo [Federation]"," West Bosnia [Federation]","Banja Luka [RS]","Bijeljina [RS]","Doboj [RS]","Fo?a [RS]","Sarajevo-Romanija [RS]","Trebinje [RS]","Vlasenica [RS]"]},{country:"Botswana",states:["Central","Ghanzi","Kgalagadi","Kgatleng","Kweneng","North East","North West","South East","Southern"]},{country:"Brazil",states:["Acre","Alagoas","Amapa","Amazonas","Bahia","Ceara","Distrito Federal","Espirito Santo","Goias","Maranhao","Mato Grosso","Mato Grosso do Sul","Minas Gerais","Para","Paraiba","Parana","Pernambuco","Piaui","Rio de Janeiro","Rio Grande do Norte","Rio Grande do Sul","Rondonia","Roraima","Santa Catarina","Sao Paulo","Sergipe","Tocantins"]},{country:"Brunei",states:["Belait","Brunei and Muara","Temburong","Tutong"]},{country:"Bulgaria",states:["Blagoevgrad","Burgas","Dobrich","Gabrovo","Khaskovo","Kurdzhali","Kyustendil","Lovech","Montana","Pazardzhik","Pernik","Pleven","Plovdiv","Razgrad","Ruse","Shumen","Silistra","Sliven","Smolyan","Sofiya","Sofiya-Grad","Stara Zagora","Turgovishte","Varna","Veliko Turnovo","Vidin","Vratsa","Yambol"]},{country:"Burkina Faso",states:["Bale","Bam","Banwa","Bazega","Bougouriba","Boulgou","Boulkiemde","Comoe","Ganzourgou","Gnagna","Gourma","Houet","Ioba","Kadiogo","Kenedougou","Komondjari","Kompienga","Kossi","Koulpelogo","Kouritenga","Kourweogo","Leraba","Loroum","Mouhoun","Namentenga","Nahouri","Nayala","Noumbiel","Oubritenga","Oudalan","Passore","Poni","Sanguie","Sanmatenga","Seno","Sissili","Soum","Sourou","Tapoa","Tuy","Yagha","Yatenga","Ziro","Zondoma","Zoundweogo"]},{country:"Burma",states:["Ayeyarwady","Bago","Magway","Mandalay","Sagaing","Tanintharyi","Yangon","Chin State","Kachin State","Kayin State","Kayah State","Mon State","Rakhine State","Shan State"]},{country:"Burundi",states:["Bubanza","Bujumbura Mairie","Bujumbura Rural","Bururi","Cankuzo","Cibitoke","Gitega","Karuzi","Kayanza","Kirundo","Makamba","Muramvya","Muyinga","Mwaro","Ngozi","Rutana","Ruyigi"]},{country:"Cambodia",states:["Banteay Mean Chey","Batdambang","Kampong Cham","Kampong Chhnang","Kampong Spoe","Kampong Thum","Kampot","Kandal","Koh Kong","Kracheh","Mondol Kiri","Otdar Mean Chey","Pouthisat","Preah Vihear","Prey Veng","Rotanakir","Siem Reab","Stoeng Treng","Svay Rieng","Takao","Keb","Pailin","Phnom Penh","Preah Seihanu"]},{country:"Cameroon",states:["Adamaoua","Centre","Est","Extreme-Nord","Littoral","Nord","Nord-Ouest","Ouest","Sud","Sud-Ouest"]},{country:"Canada",states:["Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador","Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon Territory"]},{country:"Cape Verde",states:["Santo Antão","São Vicente","Santa Luzia,","São Nicolau","Sal","Boa Vista","Maio","Santiago","Fogo","Brava"]},{country:"Central African Republic",states:["Bamingui-Bangoran","Bangui","Basse-Kotto","Haute-Kotto","Haut-Mbomou","Kemo","Lobaye","Mambere-Kadei","Mbomou","Nana-Grebizi","Nana-Mambere","Ombella-Mpoko","Ouaka","Ouham","Ouham-Pende","Sangha-Mbaere","Vakaga"]},{country:"Chad",states:["Batha","Biltine","Borkou-Ennedi-Tibesti","Chari-Baguirmi","Guéra","Kanem","Lac","Logone Occidental","Logone Oriental","Mayo-Kebbi","Moyen-Chari","Ouaddaï","Salamat","Tandjile"]},{country:"Chile",states:["Aysen","Antofagasta","Araucania","Atacama","Bio-Bio","Coquimbo","O'Higgins","Los Lagos","Magallanes y la Antartica Chilena","Maule","Santiago Region Metropolitana","Tarapaca","Valparaiso"]},{country:"China",states:["Anhui","Fujian","Gansu","Guangdong","Guizhou","Hainan","Hebei","Heilongjiang","Henan","Hubei","Hunan","Jiangsu","Jiangxi","Jilin","Liaoning","Qinghai","Shaanxi","Shandong","Shanxi","Sichuan","Yunnan","Zhejiang","Guangxi","Nei Mongol","Ningxia","Xinjiang","Xizang (Tibet)","Beijing","Chongqing","Shanghai","Tianjin"]},{country:"Colombia",states:["Amazonas","Antioquia","Arauca","Atlantico","Bogota District Capital","Bolivar","Boyaca","Caldas","Caqueta","Casanare","Cauca","Cesar","Choco","Cordoba","Cundinamarca","Guainia","Guaviare","Huila","La Guajira","Magdalena","Meta","Narino","Norte de Santander","Putumayo","Quindio","Risaralda","San Andres & Providencia","Santander","Sucre","Tolima","Valle del Cauca","Vaupes","Vichada"]},{country:"Comoros",states:["Grande Comore (Njazidja)","Anjouan (Nzwani)","Moheli (Mwali)"]},{country:"Congo, Democratic Republic",states:["Bandundu","Bas-Congo","Equateur","Kasai-Occidental","Kasai-Oriental","Katanga","Kinshasa","Maniema","Nord-Kivu","Orientale","Sud-Kivu"]},{country:"Congo, Republic of the",states:["Bouenza","Brazzaville","Cuvette","Cuvette-Ouest","Kouilou","Lekoumou","Likouala","Niari","Plateaux","Pool","Sangha"]},{country:"Costa Rica",states:["Alajuela","Cartago","Guanacaste","Heredia","Limon","Puntarenas","San Jose"]},{country:"Cote d'Ivoire",states:[]},{country:"Croatia",states:["Bjelovarsko-Bilogorska","Brodsko-Posavska","Dubrovacko-Neretvanska","Istarska","Karlovacka","Koprivnicko-Krizevacka","Krapinsko-Zagorska","Licko-Senjska","Medimurska","Osjecko-Baranjska","Pozesko-Slavonska","Primorsko-Goranska","Sibensko-Kninska","Sisacko-Moslavacka","Splitsko-Dalmatinska","Varazdinska","Viroviticko-Podravska","Vukovarsko-Srijemska","Zadarska","Zagreb","Zagrebacka"]},{country:"Cuba",states:["Camaguey","Ciego de Avila","Cienfuegos","Ciudad de La Habana","Granma","Guantanamo","Holguin","Isla de la Juventud","La Habana","Las Tunas","Matanzas","Pinar del Rio","Sancti Spiritus","Santiago de Cuba","Villa Clara"]},{country:"Cyprus",states:["Famagusta","Kyrenia","Larnaca","Limassol","Nicosia","Paphos"]},{country:"Czech Republic",states:["Jihocesky Kraj","Jihomoravsky Kraj","Karlovarsky Kraj","Kralovehradecky Kraj","Liberecky Kraj","Moravskoslezsky Kraj","Olomoucky Kraj","Pardubicky Kraj","Plzensky Kraj","Praha","Stredocesky Kraj","Ustecky Kraj","Vysocina","Zlinsky Kraj"]},{country:"Denmark",states:["Arhus","Bornholm","Frederiksberg","Frederiksborg","Fyn","Kobenhavn","Kobenhavns","Nordjylland","Ribe","Ringkobing","Roskilde","Sonderjylland","Storstrom","Vejle","Vestsjalland","Viborg"]},{country:"Djibouti",states:["Ali Sabih","Dikhil","Djibouti","Obock","Tadjoura"]},{country:"Dominica",states:["Saint Andrew","Saint David","Saint George","Saint John","Saint Joseph","Saint Luke","Saint Mark","Saint Patrick","Saint Paul","Saint Peter"]},{country:"Dominican Republic",states:["Azua","Baoruco","Barahona","Dajabon","Distrito Nacional","Duarte","Elias Pina","El Seibo","Espaillat","Hato Mayor","Independencia","La Altagracia","La Romana","La Vega","Maria Trinidad Sanchez","Monsenor Nouel","Monte Cristi","Monte Plata","Pedernales","Peravia","Puerto Plata","Salcedo","Samana","Sanchez Ramirez","San Cristobal","San Jose de Ocoa","San Juan","San Pedro de Macoris","Santiago","Santiago Rodriguez","Santo Domingo","Valverde"]},{country:"East Timor",states:["Aileu","Ainaro","Baucau","Bobonaro","Cova-Lima","Dili","Ermera","Lautem","Liquica","Manatuto","Manufahi","Oecussi","Viqueque"]},{country:"Ecuador",states:["Azuay","Bolivar","Canar","Carchi","Chimborazo","Cotopaxi","El Oro","Esmeraldas","Galapagos","Guayas","Imbabura","Loja","Los Rios","Manabi","Morona-Santiago","Napo","Orellana","Pastaza","Pichincha","Sucumbios","Tungurahua","Zamora-Chinchipe"]},{country:"Egypt",states:["Ad Daqahliyah","Al Bahr al Ahmar","Al Buhayrah","Al Fayyum","Al Gharbiyah","Al Iskandariyah","Al Isma'iliyah","Al Jizah","Al Minufiyah","Al Minya","Al Qahirah","Al Qalyubiyah","Al Wadi al Jadid","Ash Sharqiyah","As Suways","Aswan","Asyut","Bani Suwayf","Bur Sa'id","Dumyat","Janub Sina'","Kafr ash Shaykh","Matruh","Qina","Shamal Sina'","Suhaj"]},{country:"El Salvador",states:["Ahuachapan","Cabanas","Chalatenango","Cuscatlan","La Libertad","La Paz","La Union","Morazan","San Miguel","San Salvador","Santa Ana","San Vicente","Sonsonate","Usulutan"]},{country:"Equatorial Guinea",states:["Annobon","Bioko Norte","Bioko Sur","Centro Sur","Kie-Ntem","Litoral","Wele-Nzas"]},{country:"Eritrea",states:["Anseba","Debub","Debubawi K'eyih Bahri","Gash Barka","Ma'akel","Semenawi Keyih Bahri"]},{country:"Estonia",states:["Harjumaa (Tallinn)","Hiiumaa (Kardla)","Ida-Virumaa (Johvi)","Jarvamaa (Paide)","Jogevamaa (Jogeva)","Laanemaa (Haapsalu)","Laane-Virumaa (Rakvere)","Parnumaa (Parnu)","Polvamaa (Polva)","Raplamaa (Rapla)","Saaremaa (Kuressaare)","Tartumaa (Tartu)","Valgamaa (Valga)","Viljandimaa (Viljandi)","Vorumaa (Voru)"]},{country:"Ethiopia",states:["Addis Ababa","Afar","Amhara","Binshangul Gumuz","Dire Dawa","Gambela Hizboch","Harari","Oromia","Somali","Tigray","Southern Nations, Nationalities, and Peoples Region"]},{country:"Fiji",states:["Central (Suva)","Eastern (Levuka)","Northern (Labasa)","Rotuma","Western (Lautoka)"]},{country:"Finland",states:["Aland","Etela-Suomen Laani","Ita-Suomen Laani","Lansi-Suomen Laani","Lappi","Oulun Laani"]},{country:"France",states:["Alsace","Aquitaine","Auvergne","Basse-Normandie","Bourgogne","Bretagne","Centre","Champagne-Ardenne","Corse","Franche-Comte","Haute-Normandie","Ile-de-France","Languedoc-Roussillon","Limousin","Lorraine","Midi-Pyrenees","Nord-Pas-de-Calais","Pays de la Loire","Picardie","Poitou-Charentes","Provence-Alpes-Cote d'Azur","Rhone-Alpes"]},{country:"Gabon",states:["Estuaire","Haut-Ogooue","Moyen-Ogooue","Ngounie","Nyanga","Ogooue-Ivindo","Ogooue-Lolo","Ogooue-Maritime","Woleu-Ntem"]},{country:"Gambia",states:["Banjul","Central River","Lower River","North Bank","Upper River","Western"]},{country:"Georgia",states:[]},{country:"Germany",states:["Baden-Wuerttemberg","Bayern","Berlin","Brandenburg","Bremen","Hamburg","Hessen","Mecklenburg-Vorpommern","Niedersachsen","Nordrhein-Westfalen","Rheinland-Pfalz","Saarland","Sachsen","Sachsen-Anhalt","Schleswig-Holstein","Thueringen"]},{country:"Ghana",states:["Ashanti","Brong-Ahafo","Central","Eastern","Greater Accra","Northern","Upper East","Upper West","Volta","Western"]},{country:"Greece",states:["Agion Oros","Achaia","Aitolia kai Akarmania","Argolis","Arkadia","Arta","Attiki","Chalkidiki","Chanion","Chios","Dodekanisos","Drama","Evros","Evrytania","Evvoia","Florina","Fokidos","Fthiotis","Grevena","Ileia","Imathia","Ioannina","Irakleion","Karditsa","Kastoria","Kavala","Kefallinia","Kerkyra","Kilkis","Korinthia","Kozani","Kyklades","Lakonia","Larisa","Lasithi","Lefkas","Lesvos","Magnisia","Messinia","Pella","Pieria","Preveza","Rethynnis","Rodopi","Samos","Serrai","Thesprotia","Thessaloniki","Trikala","Voiotia","Xanthi","Zakynthos"]},{country:"Greenland",states:["Avannaa (Nordgronland)","Tunu (Ostgronland)","Kitaa (Vestgronland)"]},{country:"Grenada",states:["Carriacou and Petit Martinique","Saint Andrew","Saint David","Saint George","Saint John","Saint Mark","Saint Patrick"]},{country:"Guatemala",states:["Alta Verapaz","Baja Verapaz","Chimaltenango","Chiquimula","El Progreso","Escuintla","Guatemala","Huehuetenango","Izabal","Jalapa","Jutiapa","Peten","Quetzaltenango","Quiche","Retalhuleu","Sacatepequez","San Marcos","Santa Rosa","Solola","Suchitepequez","Totonicapan","Zacapa"]},{country:"Guinea",states:["Beyla","Boffa","Boke","Conakry","Coyah","Dabola","Dalaba","Dinguiraye","Dubreka","Faranah","Forecariah","Fria","Gaoual","Gueckedou","Kankan","Kerouane","Kindia","Kissidougou","Koubia","Koundara","Kouroussa","Labe","Lelouma","Lola","Macenta","Mali","Mamou","Mandiana","Nzerekore","Pita","Siguiri","Telimele","Tougue","Yomou"]},{country:"Guinea-Bissau",states:["Bafata","Biombo","Bissau","Bolama","Cacheu","Gabu","Oio","Quinara","Tombali"]},{country:"Guyana",states:["Barima-Waini","Cuyuni-Mazaruni","Demerara-Mahaica","East Berbice-Corentyne","Essequibo Islands-West Demerara","Mahaica-Berbice","Pomeroon-Supenaam","Potaro-Siparuni","Upper Demerara-Berbice","Upper Takutu-Upper Essequibo"]},{country:"Haiti",states:["Artibonite","Centre","Grand 'Anse","Nord","Nord-Est","Nord-Ouest","Ouest","Sud","Sud-Est"]},{country:"Honduras",states:["Atlantida","Choluteca","Colon","Comayagua","Copan","Cortes","El Paraiso","Francisco Morazan","Gracias a Dios","Intibuca","Islas de la Bahia","La Paz","Lempira","Ocotepeque","Olancho","Santa Barbara","Valle","Yoro"]},{country:"Hong Kong",states:["Islands","Kwai Tsing","North","Sai Kung","Sha Tin","Tai Po","Tsuen Wan","Tuen Mun","Yuen Long","Kowloon","Hong Kong Island","New Territories","Kwun Tong","Sham Shui Po","Wong Tai Sin","Yau Tsim Mong","Central and Western","Eastern","Southern","Wan Chai"]},{country:"Hungary",states:["Bacs-Kiskun","Baranya","Bekes","Borsod-Abauj-Zemplen","Csongrad","Fejer","Gyor-Moson-Sopron","Hajdu-Bihar","Heves","Jasz-Nagykun-Szolnok","Komarom-Esztergom","Nograd","Pest","Somogy","Szabolcs-Szatmar-Bereg","Tolna","Vas","Veszprem","Zala","Bekescsaba","Debrecen","Dunaujvaros","Eger","Gyor","Hodmezovasarhely","Kaposvar","Kecskemet","Miskolc","Nagykanizsa","Nyiregyhaza","Pecs","Sopron","Szeged","Szekesfehervar","Szolnok","Szombathely","Tatabanya","Veszprem","Zalaegerszeg"]},{country:"Iceland",states:["Austurland","Hofudhborgarsvaedhi","Nordhurland Eystra","Nordhurland Vestra","Sudhurland","Sudhurnes","Vestfirdhir","Vesturland"]},{country:"India",states:["Andaman and Nicobar Islands","Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chandigarh","Chhattisgarh","Dadra and Nagar Haveli","Daman and Diu","Delhi","Goa","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand","Karnataka","Kerala","Lakshadweep","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Orissa","Pondicherry","Punjab","Rajasthan","Sikkim","Tamil Nadu","Tripura","Uttaranchal","Uttar Pradesh","West Bengal"]},{country:"Indonesia",states:["Aceh","Bali","Banten","Bengkulu","Gorontalo","Irian Jaya Barat","Jakarta Raya","Jambi","Jawa Barat","Jawa Tengah","Jawa Timur","Kalimantan Barat","Kalimantan Selatan","Kalimantan Tengah","Kalimantan Timur","Kepulauan Bangka Belitung","Kepulauan Riau","Lampung","Maluku","Maluku Utara","Nusa Tenggara Barat","Nusa Tenggara Timur","Papua","Riau","Sulawesi Barat","Sulawesi Selatan","Sulawesi Tengah","Sulawesi Tenggara","Sulawesi Utara","Sumatera Barat","Sumatera Selatan","Sumatera Utara","Yogyakarta"]},{country:"Iran",states:["Ardabil","Azarbayjan-e Gharbi","Azarbayjan-e Sharqi","Bushehr","Chahar Mahall va Bakhtiari","Esfahan","Fars","Gilan","Golestan","Hamadan","Hormozgan","Ilam","Kerman","Kermanshah","Khorasan-e Janubi","Khorasan-e Razavi","Khorasan-e Shemali","Khuzestan","Kohgiluyeh va Buyer Ahmad","Kordestan","Lorestan","Markazi","Mazandaran","Qazvin","Qom","Semnan","Sistan va Baluchestan","Tehran","Yazd","Zanjan"]},{country:"Iraq",states:["Al Anbar","Al Basrah","Al Muthanna","Al Qadisiyah","An Najaf","Arbil","As Sulaymaniyah","At Ta'mim","Babil","Baghdad","Dahuk","Dhi Qar","Diyala","Karbala'","Maysan","Ninawa","Salah ad Din","Wasit"]},{country:"Ireland",states:["Carlow","Cavan","Clare","Cork","Donegal","Dublin","Galway","Kerry","Kildare","Kilkenny","Laois","Leitrim","Limerick","Longford","Louth","Mayo","Meath","Monaghan","Offaly","Roscommon","Sligo","Tipperary","Waterford","Westmeath","Wexford","Wicklow"]},{country:"Israel",states:["Central","Haifa","Jerusalem","Northern","Southern","Tel Aviv"]},{country:"Italy",states:["Abruzzo","Basilicata","Calabria","Campania","Emilia-Romagna","Friuli-Venezia Giulia","Lazio","Liguria","Lombardia","Marche","Molise","Piemonte","Puglia","Sardegna","Sicilia","Toscana","Trentino-Alto Adige","Umbria","Valle d'Aosta","Veneto"]},{country:"Jamaica",states:["Clarendon","Hanover","Kingston","Manchester","Portland","Saint Andrew","Saint Ann","Saint Catherine","Saint Elizabeth","Saint James","Saint Mary","Saint Thomas","Trelawny","Westmoreland"]},{country:"Japan",states:["Aichi","Akita","Aomori","Chiba","Ehime","Fukui","Fukuoka","Fukushima","Gifu","Gumma","Hiroshima","Hokkaido","Hyogo","Ibaraki","Ishikawa","Iwate","Kagawa","Kagoshima","Kanagawa","Kochi","Kumamoto","Kyoto","Mie","Miyagi","Miyazaki","Nagano","Nagasaki","Nara","Niigata","Oita","Okayama","Okinawa","Osaka","Saga","Saitama","Shiga","Shimane","Shizuoka","Tochigi","Tokushima","Tokyo","Tottori","Toyama","Wakayama","Yamagata","Yamaguchi","Yamanashi"]},{country:"Jordan",states:["Ajlun","Al 'Aqabah","Al Balqa'","Al Karak","Al Mafraq","'Amman","At Tafilah","Az Zarqa'","Irbid","Jarash","Ma'an","Madaba"]},{country:"Kazakhstan",states:["Almaty Oblysy","Almaty Qalasy","Aqmola Oblysy","Aqtobe Oblysy","Astana Qalasy","Atyrau Oblysy","Batys Qazaqstan Oblysy","Bayqongyr Qalasy","Mangghystau Oblysy","Ongtustik Qazaqstan Oblysy","Pavlodar Oblysy","Qaraghandy Oblysy","Qostanay Oblysy","Qyzylorda Oblysy","Shyghys Qazaqstan Oblysy","Soltustik Qazaqstan Oblysy","Zhambyl Oblysy"]},{country:"Kenya",states:["Central","Coast","Eastern","Nairobi Area","North Eastern","Nyanza","Rift Valley","Western"]},{country:"Kiribati",states:["Banaba","Tarawa","Northern Gilbert Islands","Central Gilbert Island","Southern Gilbert Islands","Line Islands"]},{country:"Korea North",states:["Chagang","North Hamgyong","South Hamgyong","North Hwanghae","South Hwanghae","Kangwon","North P'yongan","South P'yongan","Yanggang","Kaesong","Najin","Namp'o","Pyongyang"]},{country:"Korea South",states:["Seoul","Busan City","Daegu City","Incheon City","Gwangju City","Daejeon City","Ulsan","Gyeonggi Province","Gangwon Province","North Chungcheong Province","South Chungcheong Province","North Jeolla Province","South Jeolla Province","North Gyeongsang Province","South Gyeongsang Province","Jeju"]},{country:"Kuwait",states:["Al Ahmadi","Al Farwaniyah","Al Asimah","Al Jahra","Hawalli","Mubarak Al-Kabeer"]},{country:"Kyrgyzstan",states:["Batken Oblasty","Bishkek Shaary","Chuy Oblasty","Jalal-Abad Oblasty","Naryn Oblasty","Osh Oblasty","Talas Oblasty","Ysyk-Kol Oblasty"]},{country:"Laos",states:["Attapu","Bokeo","Bolikhamxai","Champasak","Houaphan","Khammouan","Louangnamtha","Louangphrabang","Oudomxai","Phongsali","Salavan","Savannakhet","Viangchan","Viangchan","Xaignabouli","Xaisomboun","Xekong","Xiangkhoang"]},{country:"Latvia",states:["Aizkraukles Rajons","Aluksnes Rajons","Balvu Rajons","Bauskas Rajons","Cesu Rajons","Daugavpils","Daugavpils Rajons","Dobeles Rajons","Gulbenes Rajons","Jekabpils Rajons","Jelgava","Jelgavas Rajons","Jurmala","Kraslavas Rajons","Kuldigas Rajons","Liepaja","Liepajas Rajons","Limbazu Rajons","Ludzas Rajons","Madonas Rajons","Ogres Rajons","Preilu Rajons","Rezekne","Rezeknes Rajons","Riga","Rigas Rajons","Saldus Rajons","Talsu Rajons","Tukuma Rajons","Valkas Rajons","Valmieras Rajons","Ventspils","Ventspils Rajons"]},{country:"Lebanon",states:["Beyrouth","Beqaa","Liban-Nord","Liban-Sud","Mont-Liban","Nabatiye"]},{country:"Lesotho",states:["Berea","Butha-Buthe","Leribe","Mafeteng","Maseru","Mohale's Hoek","Mokhotlong","Qacha's Nek","Quthing","Thaba-Tseka"]},{country:"Liberia",states:["Bomi","Bong","Gbarpolu","Grand Bassa","Grand Cape Mount","Grand Gedeh","Grand Kru","Lofa","Margibi","Maryland","Montserrado","Nimba","River Cess","River Gee","Sinoe"]},{country:"Libya",states:["Ajdabiya","Al 'Aziziyah","Al Fatih","Al Jabal al Akhdar","Al Jufrah","Al Khums","Al Kufrah","An Nuqat al Khams","Ash Shati'","Awbari","Az Zawiyah","Banghazi","Darnah","Ghadamis","Gharyan","Misratah","Murzuq","Sabha","Sawfajjin","Surt","Tarabulus","Tarhunah","Tubruq","Yafran","Zlitan"]},{country:"Liechtenstein",states:["Balzers","Eschen","Gamprin","Mauren","Planken","Ruggell","Schaan","Schellenberg","Triesen","Triesenberg","Vaduz"]},{country:"Lithuania",states:["Alytaus","Kauno","Klaipedos","Marijampoles","Panevezio","Siauliu","Taurages","Telsiu","Utenos","Vilniaus"]},{country:"Luxembourg",states:["Diekirch","Grevenmacher","Luxembourg"]},{country:"Macedonia",states:["Aerodrom","Aracinovo","Berovo","Bitola","Bogdanci","Bogovinje","Bosilovo","Brvenica","Butel","Cair","Caska","Centar","Centar Zupa","Cesinovo","Cucer-Sandevo","Debar","Debartsa","Delcevo","Demir Hisar","Demir Kapija","Dojran","Dolneni","Drugovo","Gazi Baba","Gevgelija","Gjorce Petrov","Gostivar","Gradsko","Ilinden","Jegunovce","Karbinci","Karpos","Kavadarci","Kicevo","Kisela Voda","Kocani","Konce","Kratovo","Kriva Palanka","Krivogastani","Krusevo","Kumanovo","Lipkovo","Lozovo","Makedonska Kamenica","Makedonski Brod","Mavrovo i Rastusa","Mogila","Negotino","Novaci","Novo Selo","Ohrid","Oslomej","Pehcevo","Petrovec","Plasnica","Prilep","Probistip","Radovis","Rankovce","Resen","Rosoman","Saraj","Skopje","Sopiste","Staro Nagoricane","Stip","Struga","Strumica","Studenicani","Suto Orizari","Sveti Nikole","Tearce","Tetovo","Valandovo","Vasilevo","Veles","Vevcani","Vinica","Vranestica","Vrapciste","Zajas","Zelenikovo","Zelino","Zrnovci"]},{country:"Madagascar",states:["Antananarivo","Antsiranana","Fianarantsoa","Mahajanga","Toamasina","Toliara"]},{country:"Malawi",states:["Balaka","Blantyre","Chikwawa","Chiradzulu","Chitipa","Dedza","Dowa","Karonga","Kasungu","Likoma","Lilongwe","Machinga","Mangochi","Mchinji","Mulanje","Mwanza","Mzimba","Ntcheu","Nkhata Bay","Nkhotakota","Nsanje","Ntchisi","Phalombe","Rumphi","Salima","Thyolo","Zomba"]},{country:"Malaysia",states:["Johor","Kedah","Kelantan","Kuala Lumpur","Labuan","Malacca","Negeri Sembilan","Pahang","Perak","Perlis","Penang","Sabah","Sarawak","Selangor","Terengganu"]},{country:"Maldives",states:["Alifu","Baa","Dhaalu","Faafu","Gaafu Alifu","Gaafu Dhaalu","Gnaviyani","Haa Alifu","Haa Dhaalu","Kaafu","Laamu","Lhaviyani","Maale","Meemu","Noonu","Raa","Seenu","Shaviyani","Thaa","Vaavu"]},{country:"Mali",states:["Bamako (Capital)","Gao","Kayes","Kidal","Koulikoro","Mopti","Segou","Sikasso","Tombouctou"]},{country:"Malta",states:["Southern Harbour","Northern Harbour","Western District","Northern District","Gozo and Comino"]},{country:"Marshall Islands",states:["Ailuk","Ailinglaplap","Arno","Aur","Ebon","Enewetak","Jabat","Jaluit","Kili","Kwajalein","Lae","Lib","Likiep","Majuro","Maloelap","Mejit","Mili","Namorik","Namu","Rongelap","Ujae","Utirik","Wotho","Wotje","Ailinginae","Bikar","Bikini","Bokak","Erikub","Jemo","Rongrik","Toke","Ujelang"]},{country:"Mauritania",states:["Adrar","Assaba","Brakna","Dakhlet Nouadhibou","Gorgol","Guidimaka","Hodh Ech Chargui","Hodh El Gharbi","Inchiri","Nouakchott","Tagant","Tiris Zemmour","Trarza"]},{country:"Mauritius",states:["Agalega Islands","Black River","Cargados Carajos Shoals","Flacq","Grand Port","Moka","Pamplemousses","Plaines Wilhems","Port Louis","Riviere du Rempart","Rodrigues","Savanne"]},{country:"Mexico",states:["Aguascalientes","Baja California","Baja California Sur","Campeche","Chiapas","Chihuahua","Coahuila de Zaragoza","Colima","Distrito Federal","Durango","Guanajuato","Guerrero","Hidalgo","Jalisco","Mexico","Michoacan de Ocampo","Morelos","Nayarit","Nuevo Leon","Oaxaca","Puebla","Queretaro de Arteaga","Quintana Roo","San Luis Potosi","Sinaloa","Sonora","Tabasco","Tamaulipas","Tlaxcala","Veracruz-Llave","Yucatan","Zacatecas"]},{country:"Micronesia",states:["Chuuk","Kosrae","Pohnpei","Yap"]},{country:"Moldova",states:["Anenii Noi","Basarabeasca","Briceni","Cahul","Cantemir","Calarasi","Causeni","Cimislia","Criuleni","Donduseni","Drochia","Dubasari","Edinet","Falesti","Floresti","Glodeni","Hincesti","Ialoveni","Leova","Nisporeni","Ocnita","Orhei","Rezina","Riscani","Singerei","Soldanesti","Soroca","Stefan-Voda","Straseni","Taraclia","Telenesti","Ungheni","Balti","Bender","Chisinau","Gagauzia","Stinga Nistrului"]},{country:"Mongolia",states:["Arhangay","Bayanhongor","Bayan-Olgiy","Bulgan","Darhan Uul","Dornod","Dornogovi","Dundgovi","Dzavhan","Govi-Altay","Govi-Sumber","Hentiy","Hovd","Hovsgol","Omnogovi","Orhon","Ovorhangay","Selenge","Suhbaatar","Tov","Ulaanbaatar","Uvs"]},{country:"Morocco",states:["Agadir","Al Hoceima","Azilal","Beni Mellal","Ben Slimane","Boulemane","Casablanca","Chaouen","El Jadida","El Kelaa des Sraghna","Er Rachidia","Essaouira","Fes","Figuig","Guelmim","Ifrane","Kenitra","Khemisset","Khenifra","Khouribga","Laayoune","Larache","Marrakech","Meknes","Nador","Ouarzazate","Oujda","Rabat-Sale","Safi","Settat","Sidi Kacem","Tangier","Tan-Tan","Taounate","Taroudannt","Tata","Taza","Tetouan","Tiznit"]},{country:"Monaco",states:["Monaco-Ville","La Condamine","Monte Carlo","Fontvieille"]},{country:"Mozambique",states:["Cabo Delgado","Gaza","Inhambane","Manica","Maputo","Cidade de Maputo","Nampula","Niassa","Sofala","Tete","Zambezia"]},{country:"Namibia",states:["Caprivi","Erongo","Hardap","Karas","Khomas","Kunene","Ohangwena","Okavango","Omaheke","Omusati","Oshana","Oshikoto","Otjozondjupa"]},{country:"Nauru",states:["Aiwo","Anabar","Anetan","Anibare"]},{country:"Nepal",states:["Bagmati","Bheri","Dhawalagiri","Gandaki","Janakpur","Karnali","Kosi","Lumbini","Mahakali","Mechi","Narayani","Rapti","Sagarmatha","Seti"]},{country:"Netherlands",states:["Drenthe","Flevoland","Friesland","Gelderland","Groningen","Limburg","Noord-Brabant","Noord-Holland","Overijssel","Utrecht","Zeeland","Zuid-Holland"]},{country:"New Zealand",states:["Auckland","Bay of Plenty","Canterbury","Chatham Islands","Gisborne","Hawke's Bay","Manawatu-Wanganui","Marlborough","Nelson","Northland","Otago","Southland","Taranaki","Tasman","Waikato","Wellington","West Coast"]},{country:"Nicaragua",states:["Atlantico Norte","Atlantico Sur","Boaco","Carazo","Chinandega","Chontales","Esteli","Granada","Jinotega","Leon","Madriz","Managua","Masaya","Matagalpa","Nueva Segovia","Rio San Juan","Rivas"]},{country:"Niger",states:["Agadez","Diffa","Dosso","Maradi","Niamey","Tahoua","Tillaberi","Zinder"]},{country:"Nigeria",states:["Abia","Abuja Federal Capital","Adamawa","Akwa Ibom","Anambra","Bauchi","Bayelsa","Benue","Borno","Cross River","Delta","Ebonyi","Edo","Ekiti","Enugu","Gombe","Imo","Jigawa","Kaduna","Kano","Katsina","Kebbi","Kogi","Kwara","Lagos","Nassarawa","Niger","Ogun","Ondo","Osun","Oyo","Plateau","Rivers","Sokoto","Taraba","Yobe","Zamfara"]},{country:"Norway",states:["Akershus","Aust-Agder","Buskerud","Finnmark","Hedmark","Hordaland","More og Romsdal","Nordland","Nord-Trondelag","Oppland","Oslo","Ostfold","Rogaland","Sogn og Fjordane","Sor-Trondelag","Telemark","Troms","Vest-Agder","Vestfold"]},{country:"Oman",states:["Ad Dakhiliyah","Al Batinah","Al Wusta","Ash Sharqiyah","Az Zahirah","Masqat","Musandam","Dhofar"]},{country:"Pakistan",states:["Balochistan","North-West Frontier Province","Punjab","Sindh","Islamabad Capital Territory","Federally Administered Tribal Areas"]},{country:"Panama",states:["Bocas del Toro","Chiriqui","Cocle","Colon","Darien","Herrera","Los Santos","Panama","San Blas","Veraguas"]},{country:"Papua New Guinea",states:["Bougainville","Central","Chimbu","Eastern Highlands","East New Britain","East Sepik","Enga","Gulf","Madang","Manus","Milne Bay","Morobe","National Capital","New Ireland","Northern","Sandaun","Southern Highlands","Western","Western Highlands","West New Britain"]},{country:"Paraguay",states:["Alto Paraguay","Alto Parana","Amambay","Asuncion","Boqueron","Caaguazu","Caazapa","Canindeyu","Central","Concepcion","Cordillera","Guaira","Itapua","Misiones","Neembucu","Paraguari","Presidente Hayes","San Pedro"]},{country:"Peru",states:["Amazonas","Ancash","Apurimac","Arequipa","Ayacucho","Cajamarca","Callao","Cusco","Huancavelica","Huanuco","Ica","Junin","La Libertad","Lambayeque","Lima","Loreto","Madre de Dios","Moquegua","Pasco","Piura","Puno","San Martin","Tacna","Tumbes","Ucayali"]},{country:"Philippines",states:["Abra","Agusan del Norte","Agusan del Sur","Aklan","Albay","Antique","Apayao","Aurora","Basilan","Bataan","Batanes","Batangas","Biliran","Benguet","Bohol","Bukidnon","Bulacan","Cagayan","Camarines Norte","Camarines Sur","Camiguin","Capiz","Catanduanes","Cavite","Cebu","Compostela","Davao del Norte","Davao del Sur","Davao Oriental","Eastern Samar","Guimaras","Ifugao","Ilocos Norte","Ilocos Sur","Iloilo","Isabela","Kalinga","Laguna","Lanao del Norte","Lanao del Sur","La Union","Leyte","Maguindanao","Marinduque","Masbate","Mindoro Occidental","Mindoro Oriental","Misamis Occidental","Misamis Oriental","Mountain Province","Negros Occidental","Negros Oriental","North Cotabato","Northern Samar","Nueva Ecija","Nueva Vizcaya","Palawan","Pampanga","Pangasinan","Quezon","Quirino","Rizal","Romblon","Samar","Sarangani","Siquijor","Sorsogon","South Cotabato","Southern Leyte","Sultan Kudarat","Sulu","Surigao del Norte","Surigao del Sur","Tarlac","Tawi-Tawi","Zambales","Zamboanga del Norte","Zamboanga del Sur","Zamboanga Sibugay"]},{country:"Poland",states:["Greater Poland (Wielkopolskie)","Kuyavian-Pomeranian (Kujawsko-Pomorskie)","Lesser Poland (Malopolskie)","Lodz (Lodzkie)","Lower Silesian (Dolnoslaskie)","Lublin (Lubelskie)","Lubusz (Lubuskie)","Masovian (Mazowieckie)","Opole (Opolskie)","Podlasie (Podlaskie)","Pomeranian (Pomorskie)","Silesian (Slaskie)","Subcarpathian (Podkarpackie)","Swietokrzyskie (Swietokrzyskie)","Warmian-Masurian (Warminsko-Mazurskie)","West Pomeranian (Zachodniopomorskie)"]},{country:"Portugal",states:["Aveiro","Acores","Beja","Braga","Braganca","Castelo Branco","Coimbra","Evora","Faro","Guarda","Leiria","Lisboa","Madeira","Portalegre","Porto","Santarem","Setubal","Viana do Castelo","Vila Real","Viseu"]},{country:"Qatar",states:["Ad Dawhah","Al Ghuwayriyah","Al Jumayliyah","Al Khawr","Al Wakrah","Ar Rayyan","Jarayan al Batinah","Madinat ash Shamal","Umm Sa'id","Umm Salal"]},{country:"Romania",states:["Alba","Arad","Arges","Bacau","Bihor","Bistrita-Nasaud","Botosani","Braila","Brasov","Bucuresti","Buzau","Calarasi","Caras-Severin","Cluj","Constanta","Covasna","Dimbovita","Dolj","Galati","Gorj","Giurgiu","Harghita","Hunedoara","Ialomita","Iasi","Ilfov","Maramures","Mehedinti","Mures","Neamt","Olt","Prahova","Salaj","Satu Mare","Sibiu","Suceava","Teleorman","Timis","Tulcea","Vaslui","Vilcea","Vrancea"]},{country:"Russia",states:["Amur","Arkhangel'sk","Astrakhan'","Belgorod","Bryansk","Chelyabinsk","Chita","Irkutsk","Ivanovo","Kaliningrad","Kaluga","Kamchatka","Kemerovo","Kirov","Kostroma","Kurgan","Kursk","Leningrad","Lipetsk","Magadan","Moscow","Murmansk","Nizhniy Novgorod","Novgorod","Novosibirsk","Omsk","Orenburg","Orel","Penza","Perm'","Pskov","Rostov","Ryazan'","Sakhalin","Samara","Saratov","Smolensk","Sverdlovsk","Tambov","Tomsk","Tula","Tver'","Tyumen'","Ul'yanovsk","Vladimir","Volgograd","Vologda","Voronezh","Yaroslavl'","Adygeya","Altay","Bashkortostan","Buryatiya","Chechnya","Chuvashiya","Dagestan","Ingushetiya","Kabardino-Balkariya","Kalmykiya","Karachayevo-Cherkesiya","Kareliya","Khakasiya","Komi","Mariy-El","Mordoviya","Sakha","North Ossetia","Tatarstan","Tyva","Udmurtiya","Aga Buryat","Chukotka","Evenk","Khanty-Mansi","Komi-Permyak","Koryak","Nenets","Taymyr","Ust'-Orda Buryat","Yamalo-Nenets","Altay","Khabarovsk","Krasnodar","Krasnoyarsk","Primorskiy","Stavropol'","Moscow","St. Petersburg","Yevrey"]},{country:"Rwanda",states:["Butare","Byumba","Cyangugu","Gikongoro","Gisenyi","Gitarama","Kibungo","Kibuye","Kigali Rurale","Kigali-ville","Umutara","Ruhengeri"]},{country:"Samoa",states:["A'ana","Aiga-i-le-Tai","Atua","Fa'asaleleaga","Gaga'emauga","Gagaifomauga","Palauli","Satupa'itea","Tuamasaga","Va'a-o-Fonoti","Vaisigano"]},{country:"San Marino",states:["Acquaviva","Borgo Maggiore","Chiesanuova","Domagnano","Faetano","Fiorentino","Montegiardino","San Marino Citta","Serravalle"]},{country:"Sao Tome",states:["Água Grande","Cantagalo","Caué","Lembá","Lobata","Mé-Zóchi","Autonomous Region of Príncipe"]},{country:"Saudi Arabia",states:["Al Bahah","Al Hudud ash Shamaliyah","Al Jawf","Al Madinah","Al Qasim","Ar Riyad","Ash Sharqiyah","'Asir","Ha'il","Jizan","Makkah","Najran","Tabuk"]},{country:"Senegal",states:["Dakar","Diourbel","Fatick","Kaolack","Kolda","Louga","Matam","Saint-Louis","Tambacounda","Thies","Ziguinchor"]},{country:"Serbia and Montenegro",states:["Kosovo","Montenegro","Serbia","Vojvodina"]},{country:"Seychelles",states:["Anse aux Pins","Anse Boileau","Anse Etoile","Anse Louis","Anse Royale","Baie Lazare","Baie Sainte Anne","Beau Vallon","Bel Air","Bel Ombre","Cascade","Glacis","Grand' Anse","Grand' Anse","La Digue","La Riviere Anglaise","Mont Buxton","Mont Fleuri","Plaisance","Pointe La Rue","Port Glaud","Saint Louis","Takamaka"]},{country:"Sierra Leone",states:["Eastern Province","Northern Province","Southern Province","North West Province","Western Area"]},{country:"Singapore",states:["Aljunied Group Representation Constituency","Ang Mo Kio Group Representation Constituency","Bishan–Toa Payoh Group Representation Constituency","Chua Chu Kang Group Representation Constituency","East Coast Group Representation Constituency","Holland–Bukit Timah Group Representation Constituency","Jalan Besar Group Representation Constituency","Jurong Group Representation Constituency","Marine Parade Group Representation Constituency","Marsiling–Yew Tee Group Representation Constituency","Nee Soon Group Representation Constituency","Pasir Ris–Punggol Group Representation Constituency","Sengkang Group Representation Constituency","Tampines Group Representation Constituency","Tanjong Pagar Group Representation Constituency","West Coast Group Representation Constituency"]},{country:"Slovakia",states:["Banskobystricky","Bratislavsky","Kosicky","Nitriansky","Presovsky","Trenciansky","Trnavsky","Zilinsky"]},{country:"Slovenia",states:["Ajdovscina","Beltinci","Benedikt","Bistrica ob Sotli","Bled","Bloke","Bohinj","Borovnica","Bovec","Braslovce","Brda","Brezice","Brezovica","Cankova","Celje","Cerklje na Gorenjskem","Cerknica","Cerkno","Cerkvenjak","Crensovci","Crna na Koroskem","Crnomelj","Destrnik","Divaca","Dobje","Dobrepolje","Dobrna","Dobrova-Horjul-Polhov Gradec","Dobrovnik-Dobronak","Dolenjske Toplice","Dol pri Ljubljani","Domzale","Dornava","Dravograd","Duplek","Gorenja Vas-Poljane","Gorisnica","Gornja Radgona","Gornji Grad","Gornji Petrovci","Grad","Grosuplje","Hajdina","Hoce-Slivnica","Hodos-Hodos","Horjul","Hrastnik","Hrpelje-Kozina","Idrija","Ig","Ilirska Bistrica","Ivancna Gorica","Izola-Isola","Jesenice","Jezersko","Jursinci","Kamnik","Kanal","Kidricevo","Kobarid","Kobilje","Kocevje","Komen","Komenda","Koper-Capodistria","Kostel","Kozje","Kranj","Kranjska Gora","Krizevci","Krsko","Kungota","Kuzma","Lasko","Lenart","Lendava-Lendva","Litija","Ljubljana","Ljubno","Ljutomer","Logatec","Loska Dolina","Loski Potok","Lovrenc na Pohorju","Luce","Lukovica","Majsperk","Maribor","Markovci","Medvode","Menges","Metlika","Mezica","Miklavz na Dravskem Polju","Miren-Kostanjevica","Mirna Pec","Mislinja","Moravce","Moravske Toplice","Mozirje","Murska Sobota","Muta","Naklo","Nazarje","Nova Gorica","Novo Mesto","Odranci","Oplotnica","Ormoz","Osilnica","Pesnica","Piran-Pirano","Pivka","Podcetrtek","Podlehnik","Podvelka","Polzela","Postojna","Prebold","Preddvor","Prevalje","Ptuj","Puconci","Race-Fram","Radece","Radenci","Radlje ob Dravi","Radovljica","Ravne na Koroskem","Razkrizje","Ribnica","Ribnica na Pohorju","Rogasovci","Rogaska Slatina","Rogatec","Ruse","Salovci","Selnica ob Dravi","Semic","Sempeter-Vrtojba","Sencur","Sentilj","Sentjernej","Sentjur pri Celju","Sevnica","Sezana","Skocjan","Skofja Loka","Skofljica","Slovenj Gradec","Slovenska Bistrica","Slovenske Konjice","Smarje pri Jelsah","Smartno ob Paki","Smartno pri Litiji","Sodrazica","Solcava","Sostanj","Starse","Store","Sveta Ana","Sveti Andraz v Slovenskih Goricah","Sveti Jurij","Tabor","Tisina","Tolmin","Trbovlje","Trebnje","Trnovska Vas","Trzic","Trzin","Turnisce","Velenje","Velika Polana","Velike Lasce","Verzej","Videm","Vipava","Vitanje","Vodice","Vojnik","Vransko","Vrhnika","Vuzenica","Zagorje ob Savi","Zalec","Zavrc","Zelezniki","Zetale","Ziri","Zirovnica","Zuzemberk","Zrece"]},{country:"Solomon Islands",states:["Central","Choiseul","Guadalcanal","Honiara","Isabel","Makira","Malaita","Rennell and Bellona","Temotu","Western"]},{country:"Somalia",states:["Awdal","Bakool","Banaadir","Bari","Bay","Galguduud","Gedo","Hiiraan","Jubbada Dhexe","Jubbada Hoose","Mudug","Nugaal","Sanaag","Shabeellaha Dhexe","Shabeellaha Hoose","Sool","Togdheer","Woqooyi Galbeed"]},{country:"South Africa",states:["Eastern Cape","Free State","Gauteng","KwaZulu-Natal","Limpopo","Mpumalanga","North-West","Northern Cape","Western Cape"]},{country:"Spain",states:["Andalucia","Aragon","Asturias","Baleares","Ceuta","Canarias","Cantabria","Castilla-La Mancha","Castilla y Leon","Cataluna","Comunidad Valenciana","Extremadura","Galicia","La Rioja","Madrid","Melilla","Murcia","Navarra","Pais Vasco"]},{country:"Sri Lanka",states:["Central","North Central","North Eastern","North Western","Sabaragamuwa","Southern","Uva","Western"]},{country:"Sudan",states:["A'ali an Nil","Al Bahr al Ahmar","Al Buhayrat","Al Jazirah","Al Khartum","Al Qadarif","Al Wahdah","An Nil al Abyad","An Nil al Azraq","Ash Shamaliyah","Bahr al Jabal","Gharb al Istiwa'iyah","Gharb Bahr al Ghazal","Gharb Darfur","Gharb Kurdufan","Janub Darfur","Janub Kurdufan","Junqali","Kassala","Nahr an Nil","Shamal Bahr al Ghazal","Shamal Darfur","Shamal Kurdufan","Sharq al Istiwa'iyah","Sinnar","Warab"]},{country:"Suriname",states:["Brokopondo","Commewijne","Coronie","Marowijne","Nickerie","Para","Paramaribo","Saramacca","Sipaliwini","Wanica"]},{country:"Swaziland",states:["Hhohho","Lubombo","Manzini","Shiselweni"]},{country:"Sweden",states:["Blekinge","Dalarnas","Gavleborgs","Gotlands","Hallands","Jamtlands","Jonkopings","Kalmar","Kronobergs","Norrbottens","Orebro","Ostergotlands","Skane","Sodermanlands","Stockholms","Uppsala","Varmlands","Vasterbottens","Vasternorrlands","Vastmanlands","Vastra Gotalands"]},{country:"Switzerland",states:["Aargau","Appenzell Ausser-Rhoden","Appenzell Inner-Rhoden","Basel-Landschaft","Basel-Stadt","Bern","Fribourg","Geneve","Glarus","Graubunden","Jura","Luzern","Neuchatel","Nidwalden","Obwalden","Sankt Gallen","Schaffhausen","Schwyz","Solothurn","Thurgau","Ticino","Uri","Valais","Vaud","Zug","Zurich"]},{country:"Syria",states:["Al Hasakah","Al Ladhiqiyah","Al Qunaytirah","Ar Raqqah","As Suwayda'","Dar'a","Dayr az Zawr","Dimashq","Halab","Hamah","Hims","Idlib","Rif Dimashq","Tartus"]},{country:"Taiwan",states:["Chang-hua","Chia-i","Hsin-chu","Hua-lien","I-lan","Kao-hsiung","Kin-men","Lien-chiang","Miao-li","Nan-t'ou","P'eng-hu","P'ing-tung","T'ai-chung","T'ai-nan","T'ai-pei","T'ai-tung","T'ao-yuan","Yun-lin","Chia-i","Chi-lung","Hsin-chu","T'ai-chung","T'ai-nan","Kao-hsiung city","T'ai-pei city"]},{country:"Tajikistan",states:[]},{country:"Tanzania",states:["Arusha","Dar es Salaam","Dodoma","Iringa","Kagera","Kigoma","Kilimanjaro","Lindi","Manyara","Mara","Mbeya","Morogoro","Mtwara","Mwanza","Pemba North","Pemba South","Pwani","Rukwa","Ruvuma","Shinyanga","Singida","Tabora","Tanga","Zanzibar Central/South","Zanzibar North","Zanzibar Urban/West"]},{country:"Thailand",states:["Amnat Charoen","Ang Thong","Buriram","Chachoengsao","Chai Nat","Chaiyaphum","Chanthaburi","Chiang Mai","Chiang Rai","Chon Buri","Chumphon","Kalasin","Kamphaeng Phet","Kanchanaburi","Khon Kaen","Krabi","Krung Thep Mahanakhon","Lampang","Lamphun","Loei","Lop Buri","Mae Hong Son","Maha Sarakham","Mukdahan","Nakhon Nayok","Nakhon Pathom","Nakhon Phanom","Nakhon Ratchasima","Nakhon Sawan","Nakhon Si Thammarat","Nan","Narathiwat","Nong Bua Lamphu","Nong Khai","Nonthaburi","Pathum Thani","Pattani","Phangnga","Phatthalung","Phayao","Phetchabun","Phetchaburi","Phichit","Phitsanulok","Phra Nakhon Si Ayutthaya","Phrae","Phuket","Prachin Buri","Prachuap Khiri Khan","Ranong","Ratchaburi","Rayong","Roi Et","Sa Kaeo","Sakon Nakhon","Samut Prakan","Samut Sakhon","Samut Songkhram","Sara Buri","Satun","Sing Buri","Sisaket","Songkhla","Sukhothai","Suphan Buri","Surat Thani","Surin","Tak","Trang","Trat","Ubon Ratchathani","Udon Thani","Uthai Thani","Uttaradit","Yala","Yasothon"]},{country:"Togo",states:["Kara","Plateaux","Savanes","Centrale","Maritime"]},{country:"Tonga",states:[]},{country:"Trinidad and Tobago",states:["Couva","Diego Martin","Mayaro","Penal","Princes Town","Sangre Grande","San Juan","Siparia","Tunapuna","Port-of-Spain","San Fernando","Arima","Point Fortin","Chaguanas","Tobago"]},{country:"Tunisia",states:["Ariana (Aryanah)","Beja (Bajah)","Ben Arous (Bin 'Arus)","Bizerte (Banzart)","Gabes (Qabis)","Gafsa (Qafsah)","Jendouba (Jundubah)","Kairouan (Al Qayrawan)","Kasserine (Al Qasrayn)","Kebili (Qibili)","Kef (Al Kaf)","Mahdia (Al Mahdiyah)","Manouba (Manubah)","Medenine (Madanin)","Monastir (Al Munastir)","Nabeul (Nabul)","Sfax (Safaqis)","Sidi Bou Zid (Sidi Bu Zayd)","Siliana (Silyanah)","Sousse (Susah)","Tataouine (Tatawin)","Tozeur (Tawzar)","Tunis","Zaghouan (Zaghwan)"]},{country:"Turkey",states:["Adana","Adiyaman","Afyonkarahisar","Agri","Aksaray","Amasya","Ankara","Antalya","Ardahan","Artvin","Aydin","Balikesir","Bartin","Batman","Bayburt","Bilecik","Bingol","Bitlis","Bolu","Burdur","Bursa","Canakkale","Cankiri","Corum","Denizli","Diyarbakir","Duzce","Edirne","Elazig","Erzincan","Erzurum","Eskisehir","Gaziantep","Giresun","Gumushane","Hakkari","Hatay","Igdir","Isparta","Istanbul","Izmir","Kahramanmaras","Karabuk","Karaman","Kars","Kastamonu","Kayseri","Kilis","Kirikkale","Kirklareli","Kirsehir","Kocaeli","Konya","Kutahya","Malatya","Manisa","Mardin","Mersin","Mugla","Mus","Nevsehir","Nigde","Ordu","Osmaniye","Rize","Sakarya","Samsun","Sanliurfa","Siirt","Sinop","Sirnak","Sivas","Tekirdag","Tokat","Trabzon","Tunceli","Usak","Van","Yalova","Yozgat","Zonguldak"]},{country:"Turkmenistan",states:["Ahal Welayaty (Ashgabat)","Balkan Welayaty (Balkanabat)","Dashoguz Welayaty","Lebap Welayaty (Turkmenabat)","Mary Welayaty"]},{country:"Uganda",states:["Adjumani","Apac","Arua","Bugiri","Bundibugyo","Bushenyi","Busia","Gulu","Hoima","Iganga","Jinja","Kabale","Kabarole","Kaberamaido","Kalangala","Kampala","Kamuli","Kamwenge","Kanungu","Kapchorwa","Kasese","Katakwi","Kayunga","Kibale","Kiboga","Kisoro","Kitgum","Kotido","Kumi","Kyenjojo","Lira","Luwero","Masaka","Masindi","Mayuge","Mbale","Mbarara","Moroto","Moyo","Mpigi","Mubende","Mukono","Nakapiripirit","Nakasongola","Nebbi","Ntungamo","Pader","Pallisa","Rakai","Rukungiri","Sembabule","Sironko","Soroti","Tororo","Wakiso","Yumbe"]},{country:"Ukraine",states:["Cherkasy","Chernihiv","Chernivtsi","Crimea","Dnipropetrovs'k","Donets'k","Ivano-Frankivs'k","Kharkiv","Kherson","Khmel'nyts'kyy","Kirovohrad","Kiev","Kyyiv","Luhans'k","L'viv","Mykolayiv","Odesa","Poltava","Rivne","Sevastopol'","Sumy","Ternopil'","Vinnytsya","Volyn'","Zakarpattya","Zaporizhzhya","Zhytomyr"]},{country:"United Arab Emirates",states:["Abu Dhabi","Ajman","Al Fujayrah","Sharjah","Dubai","Ra's al Khaymah","Umm al Qaywayn"]},{country:"United Kingdom",states:["Aberconwy and Colwyn","Aberdeen City","Aberdeenshire","Anglesey","Angus","Antrim","Argyll and Bute","Armagh","Avon","Ayrshire","Bath and NE Somerset","Bedfordshire","Belfast","Berkshire","Berwickshire","BFPO","Blaenau Gwent","Buckinghamshire","Caernarfonshire","Caerphilly","Caithness","Cambridgeshire","Cardiff","Cardiganshire","Carmarthenshire","Ceredigion","Channel Islands","Cheshire","City of Bristol","Clackmannanshire","Clwyd","Conwy","Cornwall/Scilly","Cumbria","Denbighshire","Derbyshire","Derry/Londonderry","Devon","Dorset","Down","Dumfries and Galloway","Dunbartonshire","Dundee","Durham","Dyfed","East Ayrshire","East Dunbartonshire","East Lothian","East Renfrewshire","East Riding Yorkshire","East Sussex","Edinburgh","England","Essex","Falkirk","Fermanagh","Fife","Flintshire","Glasgow","Gloucestershire","Greater London","Greater Manchester","Gwent","Gwynedd","Hampshire","Hartlepool","Hereford and Worcester","Hertfordshire","Highlands","Inverclyde","Inverness-Shire","Isle of Man","Isle of Wight","Kent","Kincardinshire","Kingston Upon Hull","Kinross-Shire","Kirklees","Lanarkshire","Lancashire","Leicestershire","Lincolnshire","Londonderry","Merseyside","Merthyr Tydfil","Mid Glamorgan","Mid Lothian","Middlesex","Monmouthshire","Moray","Neath & Port Talbot","Newport","Norfolk","North Ayrshire","North East Lincolnshire","North Lanarkshire","North Lincolnshire","North Somerset","North Yorkshire","Northamptonshire","Northern Ireland","Northumberland","Nottinghamshire","Orkney and Shetland Isles","Oxfordshire","Pembrokeshire","Perth and Kinross","Powys","Redcar and Cleveland","Renfrewshire","Rhonda Cynon Taff","Rutland","Scottish Borders","Shetland","Shropshire","Somerset","South Ayrshire","South Glamorgan","South Gloucesteshire","South Lanarkshire","South Yorkshire","Staffordshire","Stirling","Stockton On Tees","Suffolk","Surrey","Swansea","Torfaen","Tyne and Wear","Tyrone","Vale Of Glamorgan","Wales","Warwickshire","West Berkshire","West Dunbartonshire","West Glamorgan","West Lothian","West Midlands","West Sussex","West Yorkshire","Western Isles","Wiltshire","Wirral","Worcestershire","Wrexham","York"]},{country:"United States",states:["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"]},{country:"Uruguay",states:["Artigas","Canelones","Cerro Largo","Colonia","Durazno","Flores","Florida","Lavalleja","Maldonado","Montevideo","Paysandu","Rio Negro","Rivera","Rocha","Salto","San Jose","Soriano","Tacuarembo","Treinta y Tres"]},{country:"Uzbekistan",states:["Andijon Viloyati","Buxoro Viloyati","Farg'ona Viloyati","Jizzax Viloyati","Namangan Viloyati","Navoiy Viloyati","Qashqadaryo Viloyati","Qaraqalpog'iston Respublikasi","Samarqand Viloyati","Sirdaryo Viloyati","Surxondaryo Viloyati","Toshkent Shahri","Toshkent Viloyati","Xorazm Viloyati"]},{country:"Vanuatu",states:["Malampa","Penama","Sanma","Shefa","Tafea","Torba"]},{country:"Venezuela",states:["Amazonas","Anzoategui","Apure","Aragua","Barinas","Bolivar","Carabobo","Cojedes","Delta Amacuro","Dependencias Federales","Distrito Federal","Falcon","Guarico","Lara","Merida","Miranda","Monagas","Nueva Esparta","Portuguesa","Sucre","Tachira","Trujillo","Vargas","Yaracuy","Zulia"]},{country:"Vietnam",states:["An Giang","Bac Giang","Bac Kan","Bac Lieu","Bac Ninh","Ba Ria-Vung Tau","Ben Tre","Binh Dinh","Binh Duong","Binh Phuoc","Binh Thuan","Ca Mau","Cao Bang","Dac Lak","Dac Nong","Dien Bien","Dong Nai","Dong Thap","Gia Lai","Ha Giang","Hai Duong","Ha Nam","Ha Tay","Ha Tinh","Hau Giang","Hoa Binh","Hung Yen","Khanh Hoa","Kien Giang","Kon Tum","Lai Chau","Lam Dong","Lang Son","Lao Cai","Long An","Nam Dinh","Nghe An","Ninh Binh","Ninh Thuan","Phu Tho","Phu Yen","Quang Binh","Quang Nam","Quang Ngai","Quang Ninh","Quang Tri","Soc Trang","Son La","Tay Ninh","Thai Binh","Thai Nguyen","Thanh Hoa","Thua Thien-Hue","Tien Giang","Tra Vinh","Tuyen Quang","Vinh Long","Vinh Phuc","Yen Bai","Can Tho","Da Nang","Hai Phong","Hanoi","Ho Chi Minh"]},{country:"Yemen",states:["Abyan","'Adan","Ad Dali'","Al Bayda'","Al Hudaydah","Al Jawf","Al Mahrah","Al Mahwit","'Amran","Dhamar","Hadramawt","Hajjah","Ibb","Lahij","Ma'rib","Sa'dah","San'a'","Shabwah","Ta'izz"]},{country:"Zambia",states:["Central","Copperbelt","Eastern","Luapula","Lusaka","Northern","North-Western","Southern","Western"]},{country:"Zimbabwe",states:["Bulawayo","Harare","Manicaland","Mashonaland Central","Mashonaland East","Mashonaland West","Masvingo","Matabeleland North","Matabeleland South","Midlands"]}]}; var listItems = '';
var data = countriesVal.countries;
          listItems += '<option class="cstm_countries"> Select country </option>';
          $.each(data, function(key, value){
            var countryItem = value.country;
            countryItem = countryItem.replace("'","").replace('"',"").replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
            listItems += '<option value=' + countryItem + '>' +value.country + '</option>';
          });
          
          // add to DOM
          $("#Countries").append(listItems);

$(".field__select#Countries").change(function(){
  $('#states').find('option').remove();
    var countrydata = $(this).val();
 var listItems = '';
   listItems += '<option value="" disabled> Select State </option>';
          $.each(data, function(key, value){
             var countryItem = value.country;
            countryItem =  countryItem.replace("'","").replace('"',"").replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
           // console.log(countrydata+"===="+value.country)
            if(countrydata == countryItem){
              var states = value.states;
              $.each(states, function(statekey, statevalue){  
                 listItems += '<option value="'+ statevalue +'">'+ statevalue +'</option>';
              });
            }
          });
   $("#states").append(listItems);

//     if(data =='International'){

// $(".cstm_state").find(".field__select").attr('disabled','');
//     }else{
//         $(".cstm_state").find(".field__select").removeAttr('disabled');
//     }
});


//1 May side size chart


  $(document).ready(function () {
  $(".btn-size-chart").on("click", function (e) {
    e.preventDefault();
    $(".size-chart-content").animate({ width: "toggle" }, 600);
    $(".btn-size-chart").toggleClass("opened closed");
  });
      $(".close-call").click(function () {
    $(".size-chart-content").hide({ width: "toggle" }, 700);
  });
});

$('body').on('click', '.btn-size-chart', function(e) {
      $("body").addClass("hello-z-index"); });
$('body').on('click', '.close-call', function(e) {
  $("body").removeClass("hello-z-index"); });

// 4th template
//   $(document).ready(function () {
//   $(".popup-sustt .sus_heading ul li").on("click", function (e) {
//     e.preventDefault();
//     //$(this).parents('.popup-sustt').find('.sus-desc-popup').tgoogle
//     $(this).parents(".popup-sustt").find('.sus-desc-popup').animate({ width: "toggle" }, 600);
//     $(".popup-sustt .sus_heading ul li").toggleClass("opened closed");
//   });
//       $(".close-call-btn").click(function () {
//     $(".sus-desc-popup").hide({ width: "toggle" }, 700);
//   });
// });
$('body').on('click', '.popup-sustt .sus_heading ul li', function(e) {
      $("body").addClass("hello-y-index-temp"); });
$('body').on('click', '.close-call-btn2', function(e) {
  $("body").removeClass("hello-y-index-temp"); });

//active class 4th template
var selector = '#navMenuss li';

$(selector).on('click', function() {
  $(selector).removeClass('active-ness');
  $(this).addClass('active-ness');
});


//close siz chart popup



//close siz chart popup
// $(document).on('click', function (event) {
//   if (!$(event.target).closest('.size-chart-content').length && !$(event.target).closest('.btn-size-chart').length) {
//     // ... clicked on the 'body', but not inside of #menutop
//      $("button.close-call").trigger('click');
//   }
// });
// $(document).on('click', function (event) {
//   if (!$(event.target).closest('.sus-desc-popup').length && !$(event.target).closest('.sus_heading ul li').length) {
//     // ... clicked on the 'body', but not inside of #menutop
//      $(".close-call-btn").trigger('click');
//   }
    
// });
//wishlist

var wishlistButton = document.querySelector(".cst-wish-list");
  
  function swymCallbackFn(){    
    if(wishlistButton){
      _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);       
      // fetching all wishlist events
    }
  }
  
  function fetchCallbackFn(products){
    var activeProductId = SwymPageData.empi, 
        activeVariantId = SwymPageData.epi;
    var isInWishlist = products.find(function(p){
      return p.empi == activeProductId && p.epi == activeVariantId;
    });
    if(isInWishlist){
      wishlistButton.setAttribute("disabled", true);
      wishlistButton.innerHTML = "Added";
    } else {
      wishlistButton.addEventListener("click", function(e){
        if(SwymPageData){
          SwymPageData.et = 4;	// et 4 stands for wishlist event type
          _swat.addToWishList(SwymPageData, function(e){
            wishlistButton.innerHTML = "Added"; 
          });
        }
      });
    }
  }
  if(!window.SwymCallbacks){
   window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);



// counter product gallery
// Removed: a second `new Flickity('.product__media-list')` below 989px nested a
// zero-width .flickity-viewport inside the gallery's own instance. Its only
// consumers were the commented-out slide counter.
// $(window).resize(function(e){
// var get_width_pro = $(window).width();
// console.log(get_width_pro);
//    if(get_width_pro < 989){
//  var flkty = new Flickity('.product__media-list');
//  var carouselStatus = document.querySelector('.cstm-counter');

//  function updateStatus() {
//   alert(selectedIndex);
//    var slideNumber = flkty.selectedIndex + 1;
//    carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
//  }
//  updateStatus();

//  flkty.on( 'select', updateStatus );
   
// }else{
// flkty.flickity('destroy');

// }
// });
// $(document).ready(function(){
// myslidermob();
// });

    $(document).on("click",".product__thumbnails-item svg.icon.icon-play",function(e) {
   e.preventDefault();
   e.stopPropagation();
      $(this).addClass('hidden');      
           $(this).parents('.product__thumbnails-item').find('img').addClass('hidden');   
                $(this).parents('.product__thumbnails-item').find('.video_wrapper_custm').removeClass('hidden');           


});
 $(document).on("click",".product__thumbnails-item .video_wrapper_custm",function(e) {
   e.preventDefault();
   e.stopPropagation();
      $(this).addClass('hidden');      
           $(this).parents('.product__thumbnails-item').find('img').removeClass('hidden');   

           $(this).parents('.product__thumbnails-item').find('svg.icon.icon-play').removeClass('hidden');   

});
// document.getElementById('custom-live-chat').onclick = function() { ShopifyChat.open(); return false; }
/**** shopify chat widget ******/
if($("#custom-live-chat").length > 0){
 document.getElementById('custom-live-chat').onclick = function(e) {
    e.preventDefault(); 
    if(document.querySelectorAll("inbox-online-store-chat").length > 0){ 
   document.querySelector("inbox-online-store-chat").shadowRoot.querySelector('.chat-toggle').click();
   }
   
    // if(document.getElementById("dummy-chat-button-iframe")){ 
    //   if(document.getElementById("dummy-chat-button-iframe").contentWindow){
    //     document.getElementById("dummy-chat-button-iframe").contentWindow.document.getElementById("dummy-chat-button").addEventListener("click", dummyChatButtonIframe(), true);
    //   }else{
    //     document.getElementById("dummy-chat-button-iframe").shadowRoot.querySelector("#dummy-chat-button").addEventListener("click", dummyChatButtonIframe(), true);
    //   }
      
    // }else if( document.getElementById("ShopifyChat").contentWindow.length > 0){
    //   console.log(document.getElementById("ShopifyChat"))
    //   document.getElementById("ShopifyChat").contentWindow.document.getElementsByClassName("chat-toggle")[0].addEventListener("click", ShopifyChat(), true);
    // }
  
  }
}

//   function dummyChatButtonIframe() {
//        var iframe = document.getElementById("dummy-chat-button-iframe");
//        var elmnt  = iframe.contentWindow.document.getElementById("dummy-chat-button");
//        elmnt.click(); 
//   }

//   function ShopifyChat() { 
//      if(document.querySelectorAll("inbox-online-store-chat").length > 0){ 
//    document.querySelector("inbox-online-store-chat").shadowRoot.querySelector('.chat-toggle').click();
//    }else{
//       var iframe = document.getElementById("ShopifyChat");
//       var elmnt = iframe.contentWindow.document.getElementsByClassName("chat-toggle")[0];
//       elmnt.click();
//      }
// }

function flicktyLoad(){
  var isFlickity = true;
  $(".slider--mobile").each(function(){
  var $this = $(this);
  var id_main = $this.attr("id");  
  var flktyData = $("#"+id_main).attr('data-flickity');
  // No data-flickity means this slider is initialised by its own section
  // (the product gallery uses data-flickity-options), so leave it alone.
  // A second Flickity here nests a zero-width viewport and collapses the slides.
  if (!flktyData) { return; }
  var flktyOptions = JSON.parse(flktyData);
  if ( isFlickity ) {
  // destroy Flickity
   
    if ($("#"+id_main).hasClass("flickity-enabled")){
        $("#"+id_main).flickity('destroy');
    } 
  }
  var flkty = new Flickity("#"+id_main,flktyOptions);
  flkty.on('scroll', function( progress ) {
  var elem = $(flkty)[0]['element'];
  var id = $(elem).attr("id");
  var progressBar =  $("#"+id).parents(".multicolumn__slider").siblings('.cstm-progress-bar-jtpl');
  progress = Math.max( 0, Math.min( 1, progress ) );
  var progress_width = progress * 100 ;
  var myWidht = 50;
  if (progress_width == 0){
      $("#"+id).parents(".multicolumn__slider").siblings('.cstm-progress-bar-jtpl').attr("style","width : "+myWidht+"%");
  }
  else {
      $("#"+id).parents(".multicolumn__slider").siblings('.cstm-progress-bar-jtpl').attr("style","width : "+progress_width+"%");
  }
  if (progress_width == 100){
      $("#"+id).parents(".cstmpadding-jtpl").addClass("New-addedclass");
  }
  else{
      $("#"+id).parents(".cstmpadding-jtpl").removeClass("New-addedclass");
  }
  console.log($(".product__media-list").length)
  if($(".product__media-list").length > 0){
  var progressBar =  $("#"+id).parents("#tss-jt").siblings('.cstm-progress-bar-jtpl');
  progress = Math.max( 0, Math.min( 1, progress ) );
  var progress_width = progress * 100 ;
  var myWidht = 25;
  if (progress_width == 0){
      $("#"+id).parents("#tss-jt").siblings('.cstm-progress-bar-jtpl').attr("style","width : "+myWidht+"%");
  }
  else {
      $("#"+id).parents("#tss-jt").siblings('.cstm-progress-bar-jtpl').attr("style","width : "+progress_width+"%");
  }
  if (progress_width == 100){
      $("#"+id).parents(".cstmpadding-jtpl").addClass("New-addedclass");
  }
  else{
      $("#"+id).parents(".cstmpadding-jtpl").removeClass("New-addedclass");
  }
}

});
    
});
      
}




$(document).ready(function(){
   flicktyLoad();


 
});

// get the element to animate
var element = document.querySelector('.product__info-container');
var elementHeight = element ? element.clientHeight : 0;

if (element) {
  // listen for scroll event and call animate function
  document.addEventListener('scroll', animate);
}

// check if element is in view
function inView() {
  if (!element) return false;
  // get window height
  var windowHeight = window.innerHeight;
  // get number of pixels that the document is scrolled
  var scrollY = window.scrollY || window.pageYOffset;
  
  // get current scroll position (distance from the top of the page to the bottom of the current viewport)
  var scrollPosition = scrollY + windowHeight;
  // get element position (distance from the top of the page to the bottom of the element)
  var elementPosition = element.getBoundingClientRect().top + scrollY + elementHeight;
 // console.log(scrollPosition +"==="+elementPosition);
 // console.log(element.getBoundingClientRect().top +"==="+scrollY);
  // is scroll position greater than element position? (is element in view?) 
  var boundings = element.getBoundingClientRect().top  + 300;
  if (scrollPosition > elementPosition && boundings > 0 && scrollY > 0) {
    return true;
  }
  
  return false;
}
//$(window).on('resize scroll', animate);
// animate element when it is in view
function animate() {
  if (!element) return;
  if(inView()){
      element.classList.add('visible-jtpl');
      document.body.classList.add("header-hidden-jtpl");
  }else{
      element.classList.remove('visible-jtpl');
      document.body.classList.remove("header-hidden-jtpl");
  }
}
